export const enTitleLetters =
{
  "letter_1":[
    {
        "x": 326.8787532454446,
        "y": 252.03783759907387
    },
    {
        "x": 327.9793551082239,
        "y": 252.03783759907387
    },
    {
        "x": 327.9793551082239,
        "y": 253.13843950998685
    },
    {
        "x": 327.9793551082239,
        "y": 255.33964333181282
    },
    {
        "x": 327.9793551082239,
        "y": 256.44024524272584
    },
    {
        "x": 327.9793551082239,
        "y": 257.5408471536388
    },
    {
        "x": 327.9793551082239,
        "y": 258.6414490645518
    },
    {
        "x": 327.9793551082239,
        "y": 259.7420509754648
    },
    {
        "x": 327.9793551082239,
        "y": 260.8426528863778
    },
    {
        "x": 327.9793551082239,
        "y": 260.8426528863778
    },
    {
        "x": 327.9793551082239,
        "y": 261.94325479729076
    },
    {
        "x": 327.9793551082239,
        "y": 263.04385670820375
    },
    {
        "x": 329.0799569710032,
        "y": 264.14445861911673
    },
    {
        "x": 329.0799569710032,
        "y": 265.2450605300297
    },
    {
        "x": 329.0799569710032,
        "y": 266.3456624409427
    },
    {
        "x": 329.0799569710032,
        "y": 267.4462643518557
    },
    {
        "x": 330.18055883378247,
        "y": 268.5468662627687
    },
    {
        "x": 330.18055883378247,
        "y": 269.64746817368166
    },
    {
        "x": 330.18055883378247,
        "y": 269.64746817368166
    },
    {
        "x": 330.18055883378247,
        "y": 270.74807008459464
    },
    {
        "x": 330.18055883378247,
        "y": 271.84867199550763
    },
    {
        "x": 330.18055883378247,
        "y": 272.9492739064206
    },
    {
        "x": 330.18055883378247,
        "y": 274.0498758173336
    },
    {
        "x": 330.18055883378247,
        "y": 274.0498758173336
    },
    {
        "x": 330.18055883378247,
        "y": 275.1504777282466
    },
    {
        "x": 331.28116069656176,
        "y": 276.25107963915957
    },
    {
        "x": 331.28116069656176,
        "y": 277.35168155007256
    },
    {
        "x": 331.28116069656176,
        "y": 278.45228346098554
    },
    {
        "x": 331.28116069656176,
        "y": 278.45228346098554
    },
    {
        "x": 331.28116069656176,
        "y": 279.5528853718985
    },
    {
        "x": 331.28116069656176,
        "y": 280.6534872828115
    },
    {
        "x": 331.28116069656176,
        "y": 281.7540891937245
    },
    {
        "x": 331.28116069656176,
        "y": 282.8546911046375
    },
    {
        "x": 331.28116069656176,
        "y": 282.8546911046375
    },
    {
        "x": 331.28116069656176,
        "y": 283.95529301555047
    },
    {
        "x": 331.28116069656176,
        "y": 286.15649683737644
    },
    {
        "x": 331.28116069656176,
        "y": 287.2570987482894
    },
    {
        "x": 331.28116069656176,
        "y": 287.2570987482894
    },
    {
        "x": 331.28116069656176,
        "y": 288.3577006592024
    },
    {
        "x": 331.28116069656176,
        "y": 290.5589044810284
    },
    {
        "x": 331.28116069656176,
        "y": 291.65950639194136
    },
    {
        "x": 331.28116069656176,
        "y": 291.65950639194136
    },
    {
        "x": 331.28116069656176,
        "y": 292.76010830285435
    },
    {
        "x": 331.28116069656176,
        "y": 293.86071021376733
    },
    {
        "x": 331.28116069656176,
        "y": 294.9613121246803
    },
    {
        "x": 331.28116069656176,
        "y": 296.0619140355933
    },
    {
        "x": 331.28116069656176,
        "y": 296.0619140355933
    },
    {
        "x": 331.28116069656176,
        "y": 297.1625159465063
    },
    {
        "x": 331.28116069656176,
        "y": 298.2631178574193
    },
    {
        "x": 331.28116069656176,
        "y": 299.36371976833226
    },
    {
        "x": 331.28116069656176,
        "y": 300.46432167924524
    },
    {
        "x": 331.28116069656176,
        "y": 300.46432167924524
    },
    {
        "x": 331.28116069656176,
        "y": 301.56492359015823
    },
    {
        "x": 331.28116069656176,
        "y": 302.6655255010712
    },
    {
        "x": 331.28116069656176,
        "y": 303.7661274119842
    },
    {
        "x": 331.28116069656176,
        "y": 304.8667293228972
    },
    {
        "x": 331.28116069656176,
        "y": 304.8667293228972
    },
    {
        "x": 331.28116069656176,
        "y": 305.96733123381017
    },
    {
        "x": 331.28116069656176,
        "y": 307.06793314472316
    },
    {
        "x": 331.28116069656176,
        "y": 308.16853505563614
    },
    {
        "x": 331.28116069656176,
        "y": 309.2691369665491
    },
    {
        "x": 331.28116069656176,
        "y": 309.2691369665491
    },
    {
        "x": 331.28116069656176,
        "y": 308.16853505563614
    },
    {
        "x": 331.28116069656176,
        "y": 307.06793314472316
    },
    {
        "x": 331.28116069656176,
        "y": 304.8667293228972
    },
    {
        "x": 331.28116069656176,
        "y": 303.7661274119842
    },
    {
        "x": 331.28116069656176,
        "y": 302.6655255010712
    },
    {
        "x": 331.28116069656176,
        "y": 301.56492359015823
    },
    {
        "x": 331.28116069656176,
        "y": 300.46432167924524
    },
    {
        "x": 331.28116069656176,
        "y": 300.46432167924524
    },
    {
        "x": 331.28116069656176,
        "y": 299.36371976833226
    },
    {
        "x": 331.28116069656176,
        "y": 298.2631178574193
    },
    {
        "x": 331.28116069656176,
        "y": 297.1625159465063
    },
    {
        "x": 331.28116069656176,
        "y": 296.0619140355933
    },
    {
        "x": 331.28116069656176,
        "y": 296.0619140355933
    },
    {
        "x": 331.28116069656176,
        "y": 294.9613121246803
    },
    {
        "x": 331.28116069656176,
        "y": 293.86071021376733
    },
    {
        "x": 331.28116069656176,
        "y": 292.76010830285435
    },
    {
        "x": 331.28116069656176,
        "y": 291.65950639194136
    },
    {
        "x": 331.28116069656176,
        "y": 291.65950639194136
    },
    {
        "x": 331.28116069656176,
        "y": 290.5589044810284
    },
    {
        "x": 331.28116069656176,
        "y": 287.2570987482894
    },
    {
        "x": 331.28116069656176,
        "y": 287.2570987482894
    },
    {
        "x": 331.28116069656176,
        "y": 286.15649683737644
    },
    {
        "x": 331.28116069656176,
        "y": 283.95529301555047
    },
    {
        "x": 331.28116069656176,
        "y": 282.8546911046375
    },
    {
        "x": 331.28116069656176,
        "y": 282.8546911046375
    },
    {
        "x": 331.28116069656176,
        "y": 281.7540891937245
    },
    {
        "x": 331.28116069656176,
        "y": 280.6534872828115
    },
    {
        "x": 331.28116069656176,
        "y": 278.45228346098554
    },
    {
        "x": 331.28116069656176,
        "y": 278.45228346098554
    },
    {
        "x": 330.18055883378247,
        "y": 277.35168155007256
    },
    {
        "x": 330.18055883378247,
        "y": 276.25107963915957
    },
    {
        "x": 330.18055883378247,
        "y": 275.1504777282466
    },
    {
        "x": 330.18055883378247,
        "y": 274.0498758173336
    },
    {
        "x": 330.18055883378247,
        "y": 272.9492739064206
    },
    {
        "x": 330.18055883378247,
        "y": 271.84867199550763
    },
    {
        "x": 330.18055883378247,
        "y": 270.74807008459464
    },
    {
        "x": 330.18055883378247,
        "y": 269.64746817368166
    },
    {
        "x": 330.18055883378247,
        "y": 268.5468662627687
    },
    {
        "x": 330.18055883378247,
        "y": 267.4462643518557
    },
    {
        "x": 330.18055883378247,
        "y": 266.3456624409427
    },
    {
        "x": 330.18055883378247,
        "y": 265.2450605300297
    },
    {
        "x": 330.18055883378247,
        "y": 265.2450605300297
    },
    {
        "x": 330.18055883378247,
        "y": 263.04385670820375
    },
    {
        "x": 330.18055883378247,
        "y": 261.94325479729076
    },
    {
        "x": 330.18055883378247,
        "y": 260.8426528863778
    },
    {
        "x": 333.48236442212027,
        "y": 258.6414490645518
    },
    {
        "x": 334.58296628489956,
        "y": 258.6414490645518
    },
    {
        "x": 334.58296628489956,
        "y": 257.5408471536388
    },
    {
        "x": 334.58296628489956,
        "y": 257.5408471536388
    },
    {
        "x": 334.58296628489956,
        "y": 256.44024524272584
    },
    {
        "x": 335.68356814767884,
        "y": 256.44024524272584
    },
    {
        "x": 335.68356814767884,
        "y": 256.44024524272584
    },
    {
        "x": 336.7841700104581,
        "y": 256.44024524272584
    },
    {
        "x": 337.88477187323736,
        "y": 256.44024524272584
    },
    {
        "x": 337.88477187323736,
        "y": 255.33964333181282
    },
    {
        "x": 338.98537373601664,
        "y": 255.33964333181282
    },
    {
        "x": 340.0859755987959,
        "y": 253.13843950998685
    },
    {
        "x": 341.1865774615752,
        "y": 253.13843950998685
    },
    {
        "x": 342.2871793243545,
        "y": 253.13843950998685
    },
    {
        "x": 343.3877811871338,
        "y": 253.13843950998685
    },
    {
        "x": 343.3877811871338,
        "y": 252.03783759907387
    },
    {
        "x": 344.488383049913,
        "y": 252.03783759907387
    },
    {
        "x": 346.6895867754716,
        "y": 252.03783759907387
    },
    {
        "x": 347.79018863825087,
        "y": 252.03783759907387
    },
    {
        "x": 347.79018863825087,
        "y": 252.03783759907387
    },
    {
        "x": 348.89079050103015,
        "y": 252.03783759907387
    },
    {
        "x": 349.9913923638094,
        "y": 252.03783759907387
    },
    {
        "x": 351.09199422658867,
        "y": 252.03783759907387
    },
    {
        "x": 352.19259608936795,
        "y": 252.03783759907387
    },
    {
        "x": 352.19259608936795,
        "y": 252.03783759907387
    },
    {
        "x": 353.29319795214724,
        "y": 252.03783759907387
    },
    {
        "x": 354.3937998149265,
        "y": 253.13843950998685
    },
    {
        "x": 355.49440167770575,
        "y": 254.23904142089984
    },
    {
        "x": 356.59500354048504,
        "y": 255.33964333181282
    },
    {
        "x": 356.59500354048504,
        "y": 255.33964333181282
    },
    {
        "x": 357.6956054032643,
        "y": 255.33964333181282
    },
    {
        "x": 357.6956054032643,
        "y": 256.44024524272584
    },
    {
        "x": 358.7962072660436,
        "y": 256.44024524272584
    },
    {
        "x": 359.8968091288229,
        "y": 257.5408471536388
    },
    {
        "x": 360.9974109916021,
        "y": 258.6414490645518
    },
    {
        "x": 360.9974109916021,
        "y": 259.7420509754648
    },
    {
        "x": 360.9974109916021,
        "y": 260.8426528863778
    },
    {
        "x": 362.0980128543814,
        "y": 260.8426528863778
    },
    {
        "x": 362.0980128543814,
        "y": 261.94325479729076
    },
    {
        "x": 362.0980128543814,
        "y": 263.04385670820375
    },
    {
        "x": 363.1986147171607,
        "y": 264.14445861911673
    },
    {
        "x": 363.1986147171607,
        "y": 265.2450605300297
    },
    {
        "x": 363.1986147171607,
        "y": 265.2450605300297
    },
    {
        "x": 364.29921657994,
        "y": 265.2450605300297
    },
    {
        "x": 365.39981844271927,
        "y": 266.3456624409427
    },
    {
        "x": 365.39981844271927,
        "y": 267.4462643518557
    },
    {
        "x": 365.39981844271927,
        "y": 268.5468662627687
    },
    {
        "x": 365.39981844271927,
        "y": 269.64746817368166
    },
    {
        "x": 365.39981844271927,
        "y": 269.64746817368166
    },
    {
        "x": 365.39981844271927,
        "y": 271.84867199550763
    },
    {
        "x": 365.39981844271927,
        "y": 274.0498758173336
    },
    {
        "x": 365.39981844271927,
        "y": 274.0498758173336
    },
    {
        "x": 365.39981844271927,
        "y": 275.1504777282466
    },
    {
        "x": 365.39981844271927,
        "y": 276.25107963915957
    },
    {
        "x": 365.39981844271927,
        "y": 277.35168155007256
    },
    {
        "x": 365.39981844271927,
        "y": 278.45228346098554
    },
    {
        "x": 365.39981844271927,
        "y": 278.45228346098554
    },
    {
        "x": 365.39981844271927,
        "y": 279.5528853718985
    },
    {
        "x": 365.39981844271927,
        "y": 280.6534872828115
    },
    {
        "x": 365.39981844271927,
        "y": 281.7540891937245
    },
    {
        "x": 365.39981844271927,
        "y": 282.8546911046375
    },
    {
        "x": 365.39981844271927,
        "y": 282.8546911046375
    },
    {
        "x": 365.39981844271927,
        "y": 283.95529301555047
    },
    {
        "x": 366.50042030549855,
        "y": 285.05589492646345
    },
    {
        "x": 366.50042030549855,
        "y": 286.15649683737644
    },
    {
        "x": 366.50042030549855,
        "y": 287.2570987482894
    },
    {
        "x": 366.50042030549855,
        "y": 287.2570987482894
    },
    {
        "x": 366.50042030549855,
        "y": 288.3577006592024
    },
    {
        "x": 366.50042030549855,
        "y": 289.4583025701154
    },
    {
        "x": 366.50042030549855,
        "y": 290.5589044810284
    },
    {
        "x": 366.50042030549855,
        "y": 291.65950639194136
    },
    {
        "x": 366.50042030549855,
        "y": 291.65950639194136
    },
    {
        "x": 366.50042030549855,
        "y": 292.76010830285435
    },
    {
        "x": 366.50042030549855,
        "y": 293.86071021376733
    },
    {
        "x": 366.50042030549855,
        "y": 294.9613121246803
    },
    {
        "x": 366.50042030549855,
        "y": 296.0619140355933
    },
    {
        "x": 366.50042030549855,
        "y": 296.0619140355933
    },
    {
        "x": 366.50042030549855,
        "y": 297.1625159465063
    },
    {
        "x": 366.50042030549855,
        "y": 298.2631178574193
    },
    {
        "x": 366.50042030549855,
        "y": 299.36371976833226
    },
    {
        "x": 366.50042030549855,
        "y": 300.46432167924524
    },
    {
        "x": 366.50042030549855,
        "y": 300.46432167924524
    },
    {
        "x": 366.50042030549855,
        "y": 301.56492359015823
    },
    {
        "x": 366.50042030549855,
        "y": 302.6655255010712
    },
    {
        "x": 366.50042030549855,
        "y": 303.7661274119842
    },
    {
        "x": 366.50042030549855,
        "y": 302.6655255010712
    },
    {
        "x": 366.50042030549855,
        "y": 301.56492359015823
    },
    {
        "x": 366.50042030549855,
        "y": 300.46432167924524
    },
    {
        "x": 366.50042030549855,
        "y": 300.46432167924524
    },
    {
        "x": 366.50042030549855,
        "y": 299.36371976833226
    },
    {
        "x": 366.50042030549855,
        "y": 298.2631178574193
    },
    {
        "x": 366.50042030549855,
        "y": 297.1625159465063
    },
    {
        "x": 366.50042030549855,
        "y": 296.0619140355933
    },
    {
        "x": 366.50042030549855,
        "y": 294.9613121246803
    },
    {
        "x": 366.50042030549855,
        "y": 293.86071021376733
    },
    {
        "x": 366.50042030549855,
        "y": 291.65950639194136
    },
    {
        "x": 366.50042030549855,
        "y": 291.65950639194136
    },
    {
        "x": 366.50042030549855,
        "y": 290.5589044810284
    },
    {
        "x": 366.50042030549855,
        "y": 288.3577006592024
    },
    {
        "x": 366.50042030549855,
        "y": 287.2570987482894
    },
    {
        "x": 366.50042030549855,
        "y": 287.2570987482894
    },
    {
        "x": 366.50042030549855,
        "y": 286.15649683737644
    },
    {
        "x": 365.39981844271927,
        "y": 285.05589492646345
    },
    {
        "x": 365.39981844271927,
        "y": 283.95529301555047
    },
    {
        "x": 365.39981844271927,
        "y": 282.8546911046375
    },
    {
        "x": 365.39981844271927,
        "y": 281.7540891937245
    },
    {
        "x": 365.39981844271927,
        "y": 280.6534872828115
    },
    {
        "x": 365.39981844271927,
        "y": 279.5528853718985
    },
    {
        "x": 365.39981844271927,
        "y": 278.45228346098554
    },
    {
        "x": 365.39981844271927,
        "y": 278.45228346098554
    },
    {
        "x": 365.39981844271927,
        "y": 276.25107963915957
    },
    {
        "x": 364.29921657994,
        "y": 275.1504777282466
    },
    {
        "x": 364.29921657994,
        "y": 274.0498758173336
    },
    {
        "x": 364.29921657994,
        "y": 274.0498758173336
    },
    {
        "x": 364.29921657994,
        "y": 272.9492739064206
    },
    {
        "x": 364.29921657994,
        "y": 270.74807008459464
    },
    {
        "x": 364.29921657994,
        "y": 269.64746817368166
    },
    {
        "x": 364.29921657994,
        "y": 269.64746817368166
    },
    {
        "x": 364.29921657994,
        "y": 268.5468662627687
    },
    {
        "x": 364.29921657994,
        "y": 267.4462643518557
    },
    {
        "x": 364.29921657994,
        "y": 266.3456624409427
    },
    {
        "x": 364.29921657994,
        "y": 265.2450605300297
    },
    {
        "x": 364.29921657994,
        "y": 265.2450605300297
    },
    {
        "x": 364.29921657994,
        "y": 264.14445861911673
    },
    {
        "x": 364.29921657994,
        "y": 263.04385670820375
    },
    {
        "x": 364.29921657994,
        "y": 261.94325479729076
    },
    {
        "x": 364.29921657994,
        "y": 260.8426528863778
    },
    {
        "x": 364.29921657994,
        "y": 260.8426528863778
    },
    {
        "x": 364.29921657994,
        "y": 259.7420509754648
    },
    {
        "x": 365.39981844271927,
        "y": 258.6414490645518
    },
    {
        "x": 365.39981844271927,
        "y": 257.5408471536388
    },
    {
        "x": 365.39981844271927,
        "y": 256.44024524272584
    },
    {
        "x": 366.50042030549855,
        "y": 255.33964333181282
    },
    {
        "x": 367.6010221682778,
        "y": 255.33964333181282
    },
    {
        "x": 368.70162403105707,
        "y": 255.33964333181282
    },
    {
        "x": 368.70162403105707,
        "y": 254.23904142089984
    },
    {
        "x": 369.80222589383635,
        "y": 254.23904142089984
    },
    {
        "x": 369.80222589383635,
        "y": 253.13843950998685
    },
    {
        "x": 370.90282775661564,
        "y": 253.13843950998685
    },
    {
        "x": 373.10403148217415,
        "y": 253.13843950998685
    },
    {
        "x": 374.20463334495344,
        "y": 253.13843950998685
    },
    {
        "x": 374.20463334495344,
        "y": 253.13843950998685
    },
    {
        "x": 375.3052352077327,
        "y": 253.13843950998685
    },
    {
        "x": 378.6070407960706,
        "y": 252.03783759907387
    },
    {
        "x": 379.7076426588498,
        "y": 252.03783759907387
    },
    {
        "x": 380.8082445216291,
        "y": 252.03783759907387
    },
    {
        "x": 381.9088463844084,
        "y": 252.03783759907387
    },
    {
        "x": 383.00944824718766,
        "y": 252.03783759907387
    },
    {
        "x": 383.00944824718766,
        "y": 252.03783759907387
    },
    {
        "x": 384.11005010996695,
        "y": 252.03783759907387
    },
    {
        "x": 385.2106519727462,
        "y": 252.03783759907387
    },
    {
        "x": 387.41185569830475,
        "y": 252.03783759907387
    },
    {
        "x": 387.41185569830475,
        "y": 252.03783759907387
    },
    {
        "x": 388.51245756108403,
        "y": 252.03783759907387
    },
    {
        "x": 389.6130594238633,
        "y": 252.03783759907387
    },
    {
        "x": 390.71366128664255,
        "y": 252.03783759907387
    },
    {
        "x": 391.81426314942183,
        "y": 252.03783759907387
    },
    {
        "x": 391.81426314942183,
        "y": 252.03783759907387
    },
    {
        "x": 392.9148650122011,
        "y": 253.13843950998685
    },
    {
        "x": 394.0154668749804,
        "y": 254.23904142089984
    },
    {
        "x": 394.0154668749804,
        "y": 255.33964333181282
    },
    {
        "x": 395.1160687377597,
        "y": 256.44024524272584
    },
    {
        "x": 395.1160687377597,
        "y": 256.44024524272584
    },
    {
        "x": 396.2166706005389,
        "y": 256.44024524272584
    },
    {
        "x": 396.2166706005389,
        "y": 257.5408471536388
    },
    {
        "x": 396.2166706005389,
        "y": 258.6414490645518
    },
    {
        "x": 396.2166706005389,
        "y": 259.7420509754648
    },
    {
        "x": 397.3172724633182,
        "y": 260.8426528863778
    },
    {
        "x": 398.4178743260975,
        "y": 260.8426528863778
    },
    {
        "x": 398.4178743260975,
        "y": 263.04385670820375
    },
    {
        "x": 399.5184761888768,
        "y": 264.14445861911673
    },
    {
        "x": 399.5184761888768,
        "y": 265.2450605300297
    },
    {
        "x": 399.5184761888768,
        "y": 265.2450605300297
    },
    {
        "x": 400.61907805165606,
        "y": 266.3456624409427
    },
    {
        "x": 400.61907805165606,
        "y": 267.4462643518557
    },
    {
        "x": 400.61907805165606,
        "y": 268.5468662627687
    },
    {
        "x": 400.61907805165606,
        "y": 269.64746817368166
    },
    {
        "x": 401.71967991443535,
        "y": 269.64746817368166
    },
    {
        "x": 402.8202817772146,
        "y": 270.74807008459464
    },
    {
        "x": 402.8202817772146,
        "y": 271.84867199550763
    },
    {
        "x": 402.8202817772146,
        "y": 272.9492739064206
    },
    {
        "x": 402.8202817772146,
        "y": 274.0498758173336
    },
    {
        "x": 402.8202817772146,
        "y": 274.0498758173336
    },
    {
        "x": 402.8202817772146,
        "y": 275.1504777282466
    },
    {
        "x": 402.8202817772146,
        "y": 276.25107963915957
    },
    {
        "x": 402.8202817772146,
        "y": 277.35168155007256
    },
    {
        "x": 402.8202817772146,
        "y": 278.45228346098554
    },
    {
        "x": 402.8202817772146,
        "y": 278.45228346098554
    },
    {
        "x": 402.8202817772146,
        "y": 279.5528853718985
    },
    {
        "x": 402.8202817772146,
        "y": 280.6534872828115
    },
    {
        "x": 402.8202817772146,
        "y": 281.7540891937245
    },
    {
        "x": 402.8202817772146,
        "y": 282.8546911046375
    },
    {
        "x": 402.8202817772146,
        "y": 282.8546911046375
    },
    {
        "x": 402.8202817772146,
        "y": 283.95529301555047
    },
    {
        "x": 402.8202817772146,
        "y": 285.05589492646345
    },
    {
        "x": 402.8202817772146,
        "y": 286.15649683737644
    },
    {
        "x": 402.8202817772146,
        "y": 287.2570987482894
    },
    {
        "x": 402.8202817772146,
        "y": 287.2570987482894
    },
    {
        "x": 402.8202817772146,
        "y": 288.3577006592024
    },
    {
        "x": 402.8202817772146,
        "y": 289.4583025701154
    },
    {
        "x": 402.8202817772146,
        "y": 290.5589044810284
    },
    {
        "x": 401.71967991443535,
        "y": 291.65950639194136
    },
    {
        "x": 401.71967991443535,
        "y": 291.65950639194136
    },
    {
        "x": 401.71967991443535,
        "y": 292.76010830285435
    },
    {
        "x": 401.71967991443535,
        "y": 293.86071021376733
    },
    {
        "x": 401.71967991443535,
        "y": 294.9613121246803
    },
    {
        "x": 401.71967991443535,
        "y": 296.0619140355933
    },
    {
        "x": 401.71967991443535,
        "y": 296.0619140355933
    },
    {
        "x": 401.71967991443535,
        "y": 297.1625159465063
    },
    {
        "x": 401.71967991443535,
        "y": 298.2631178574193
    },
    {
        "x": 401.71967991443535,
        "y": 299.36371976833226
    },
    {
        "x": 401.71967991443535,
        "y": 300.46432167924524
    },
    {
        "x": 401.71967991443535,
        "y": 300.46432167924524
    },
    {
        "x": 401.71967991443535,
        "y": 301.56492359015823
    },
    {
        "x": 401.71967991443535,
        "y": 302.6655255010712
    },
    {
        "x": 401.71967991443535,
        "y": 303.7661274119842
    },
    {
        "x": 401.71967991443535,
        "y": 304.8667293228972
    }
],
  "letter_2":[
    {
        "x": 461.15218050451614,
        "y": 245.43422613359596
    },
    {
        "x": 461.15218050451614,
        "y": 246.53482804450894
    },
    {
        "x": 461.15218050451614,
        "y": 247.63542995542193
    },
    {
        "x": 461.15218050451614,
        "y": 249.8366337772479
    },
    {
        "x": 461.15218050451614,
        "y": 250.93723568816088
    },
    {
        "x": 461.15218050451614,
        "y": 252.03783759907387
    },
    {
        "x": 461.15218050451614,
        "y": 252.03783759907387
    },
    {
        "x": 461.15218050451614,
        "y": 253.13843950998685
    },
    {
        "x": 461.15218050451614,
        "y": 254.23904142089984
    },
    {
        "x": 461.15218050451614,
        "y": 255.33964333181282
    },
    {
        "x": 461.15218050451614,
        "y": 256.44024524272584
    },
    {
        "x": 461.15218050451614,
        "y": 256.44024524272584
    },
    {
        "x": 461.15218050451614,
        "y": 257.5408471536388
    },
    {
        "x": 461.15218050451614,
        "y": 258.6414490645518
    },
    {
        "x": 461.15218050451614,
        "y": 259.7420509754648
    },
    {
        "x": 461.15218050451614,
        "y": 260.8426528863778
    },
    {
        "x": 461.15218050451614,
        "y": 260.8426528863778
    },
    {
        "x": 461.15218050451614,
        "y": 261.94325479729076
    },
    {
        "x": 461.15218050451614,
        "y": 263.04385670820375
    },
    {
        "x": 461.15218050451614,
        "y": 264.14445861911673
    },
    {
        "x": 461.15218050451614,
        "y": 265.2450605300297
    },
    {
        "x": 461.15218050451614,
        "y": 265.2450605300297
    },
    {
        "x": 461.15218050451614,
        "y": 266.3456624409427
    },
    {
        "x": 461.15218050451614,
        "y": 267.4462643518557
    },
    {
        "x": 461.15218050451614,
        "y": 268.5468662627687
    },
    {
        "x": 461.15218050451614,
        "y": 269.64746817368166
    },
    {
        "x": 461.15218050451614,
        "y": 269.64746817368166
    },
    {
        "x": 461.15218050451614,
        "y": 269.64746817368166
    },
    {
        "x": 461.15218050451614,
        "y": 268.5468662627687
    },
    {
        "x": 460.0515786417369,
        "y": 268.5468662627687
    },
    {
        "x": 460.0515786417369,
        "y": 267.4462643518557
    },
    {
        "x": 460.0515786417369,
        "y": 266.3456624409427
    },
    {
        "x": 458.9509767789576,
        "y": 266.3456624409427
    },
    {
        "x": 457.85037491617834,
        "y": 265.2450605300297
    },
    {
        "x": 457.85037491617834,
        "y": 265.2450605300297
    },
    {
        "x": 457.85037491617834,
        "y": 264.14445861911673
    },
    {
        "x": 457.85037491617834,
        "y": 263.04385670820375
    },
    {
        "x": 456.74977305339905,
        "y": 261.94325479729076
    },
    {
        "x": 455.64917119061977,
        "y": 260.8426528863778
    },
    {
        "x": 455.64917119061977,
        "y": 260.8426528863778
    },
    {
        "x": 454.54856932784054,
        "y": 259.7420509754648
    },
    {
        "x": 453.44796746506125,
        "y": 258.6414490645518
    },
    {
        "x": 453.44796746506125,
        "y": 257.5408471536388
    },
    {
        "x": 453.44796746506125,
        "y": 256.44024524272584
    },
    {
        "x": 452.34736560228197,
        "y": 256.44024524272584
    },
    {
        "x": 451.2467637395027,
        "y": 255.33964333181282
    },
    {
        "x": 451.2467637395027,
        "y": 254.23904142089984
    },
    {
        "x": 450.1461618767234,
        "y": 253.13843950998685
    },
    {
        "x": 449.04556001394417,
        "y": 253.13843950998685
    },
    {
        "x": 449.04556001394417,
        "y": 252.03783759907387
    },
    {
        "x": 447.9449581511649,
        "y": 252.03783759907387
    },
    {
        "x": 447.9449581511649,
        "y": 250.93723568816088
    },
    {
        "x": 446.8443562883856,
        "y": 250.93723568816088
    },
    {
        "x": 445.7437544256063,
        "y": 249.8366337772479
    },
    {
        "x": 444.643152562827,
        "y": 248.7360318663349
    },
    {
        "x": 444.643152562827,
        "y": 248.7360318663349
    },
    {
        "x": 443.54255070004774,
        "y": 248.7360318663349
    },
    {
        "x": 442.4419488372685,
        "y": 248.7360318663349
    },
    {
        "x": 441.3413469744892,
        "y": 248.7360318663349
    },
    {
        "x": 440.24074511170994,
        "y": 248.7360318663349
    },
    {
        "x": 440.24074511170994,
        "y": 248.7360318663349
    },
    {
        "x": 439.14014324893066,
        "y": 248.7360318663349
    },
    {
        "x": 438.03954138615137,
        "y": 248.7360318663349
    },
    {
        "x": 436.93893952337214,
        "y": 248.7360318663349
    },
    {
        "x": 435.83833766059286,
        "y": 248.7360318663349
    },
    {
        "x": 435.83833766059286,
        "y": 249.8366337772479
    },
    {
        "x": 434.73773579781357,
        "y": 249.8366337772479
    },
    {
        "x": 433.6371339350343,
        "y": 249.8366337772479
    },
    {
        "x": 431.4359302094757,
        "y": 250.93723568816088
    },
    {
        "x": 429.2347264839172,
        "y": 250.93723568816088
    },
    {
        "x": 429.2347264839172,
        "y": 252.03783759907387
    },
    {
        "x": 428.1341246211379,
        "y": 252.03783759907387
    },
    {
        "x": 427.03352275835863,
        "y": 252.03783759907387
    },
    {
        "x": 427.03352275835863,
        "y": 252.03783759907387
    },
    {
        "x": 427.03352275835863,
        "y": 253.13843950998685
    },
    {
        "x": 424.8323190328001,
        "y": 254.23904142089984
    },
    {
        "x": 424.8323190328001,
        "y": 255.33964333181282
    },
    {
        "x": 423.73171717002083,
        "y": 255.33964333181282
    },
    {
        "x": 422.63111530724154,
        "y": 255.33964333181282
    },
    {
        "x": 422.63111530724154,
        "y": 256.44024524272584
    },
    {
        "x": 422.63111530724154,
        "y": 256.44024524272584
    },
    {
        "x": 422.63111530724154,
        "y": 257.5408471536388
    },
    {
        "x": 422.63111530724154,
        "y": 258.6414490645518
    },
    {
        "x": 421.53051344446226,
        "y": 258.6414490645518
    },
    {
        "x": 421.53051344446226,
        "y": 259.7420509754648
    },
    {
        "x": 421.53051344446226,
        "y": 260.8426528863778
    },
    {
        "x": 421.53051344446226,
        "y": 260.8426528863778
    },
    {
        "x": 421.53051344446226,
        "y": 261.94325479729076
    },
    {
        "x": 421.53051344446226,
        "y": 263.04385670820375
    },
    {
        "x": 421.53051344446226,
        "y": 264.14445861911673
    },
    {
        "x": 421.53051344446226,
        "y": 265.2450605300297
    },
    {
        "x": 421.53051344446226,
        "y": 265.2450605300297
    },
    {
        "x": 421.53051344446226,
        "y": 266.3456624409427
    },
    {
        "x": 421.53051344446226,
        "y": 267.4462643518557
    },
    {
        "x": 421.53051344446226,
        "y": 268.5468662627687
    },
    {
        "x": 421.53051344446226,
        "y": 269.64746817368166
    },
    {
        "x": 421.53051344446226,
        "y": 269.64746817368166
    },
    {
        "x": 421.53051344446226,
        "y": 270.74807008459464
    },
    {
        "x": 421.53051344446226,
        "y": 271.84867199550763
    },
    {
        "x": 421.53051344446226,
        "y": 272.9492739064206
    },
    {
        "x": 421.53051344446226,
        "y": 274.0498758173336
    },
    {
        "x": 421.53051344446226,
        "y": 274.0498758173336
    },
    {
        "x": 421.53051344446226,
        "y": 276.25107963915957
    },
    {
        "x": 421.53051344446226,
        "y": 277.35168155007256
    },
    {
        "x": 421.53051344446226,
        "y": 278.45228346098554
    },
    {
        "x": 421.53051344446226,
        "y": 278.45228346098554
    },
    {
        "x": 421.53051344446226,
        "y": 279.5528853718985
    },
    {
        "x": 421.53051344446226,
        "y": 281.7540891937245
    },
    {
        "x": 421.53051344446226,
        "y": 282.8546911046375
    },
    {
        "x": 421.53051344446226,
        "y": 282.8546911046375
    },
    {
        "x": 421.53051344446226,
        "y": 283.95529301555047
    },
    {
        "x": 422.63111530724154,
        "y": 285.05589492646345
    },
    {
        "x": 422.63111530724154,
        "y": 286.15649683737644
    },
    {
        "x": 422.63111530724154,
        "y": 287.2570987482894
    },
    {
        "x": 423.73171717002083,
        "y": 287.2570987482894
    },
    {
        "x": 424.8323190328001,
        "y": 287.2570987482894
    },
    {
        "x": 425.93292089557934,
        "y": 287.2570987482894
    },
    {
        "x": 427.03352275835863,
        "y": 288.3577006592024
    },
    {
        "x": 428.1341246211379,
        "y": 289.4583025701154
    },
    {
        "x": 429.2347264839172,
        "y": 289.4583025701154
    },
    {
        "x": 430.3353283466965,
        "y": 290.5589044810284
    },
    {
        "x": 431.4359302094757,
        "y": 290.5589044810284
    },
    {
        "x": 432.536532072255,
        "y": 291.65950639194136
    },
    {
        "x": 433.6371339350343,
        "y": 291.65950639194136
    },
    {
        "x": 434.73773579781357,
        "y": 291.65950639194136
    },
    {
        "x": 435.83833766059286,
        "y": 291.65950639194136
    },
    {
        "x": 435.83833766059286,
        "y": 291.65950639194136
    },
    {
        "x": 436.93893952337214,
        "y": 291.65950639194136
    },
    {
        "x": 436.93893952337214,
        "y": 291.65950639194136
    },
    {
        "x": 438.03954138615137,
        "y": 291.65950639194136
    },
    {
        "x": 439.14014324893066,
        "y": 292.76010830285435
    },
    {
        "x": 440.24074511170994,
        "y": 292.76010830285435
    },
    {
        "x": 440.24074511170994,
        "y": 292.76010830285435
    },
    {
        "x": 441.3413469744892,
        "y": 293.86071021376733
    },
    {
        "x": 442.4419488372685,
        "y": 293.86071021376733
    },
    {
        "x": 443.54255070004774,
        "y": 294.9613121246803
    },
    {
        "x": 444.643152562827,
        "y": 294.9613121246803
    },
    {
        "x": 444.643152562827,
        "y": 294.9613121246803
    },
    {
        "x": 445.7437544256063,
        "y": 294.9613121246803
    },
    {
        "x": 446.8443562883856,
        "y": 294.9613121246803
    },
    {
        "x": 447.9449581511649,
        "y": 294.9613121246803
    },
    {
        "x": 450.1461618767234,
        "y": 294.9613121246803
    },
    {
        "x": 452.34736560228197,
        "y": 293.86071021376733
    },
    {
        "x": 453.44796746506125,
        "y": 292.76010830285435
    },
    {
        "x": 453.44796746506125,
        "y": 292.76010830285435
    },
    {
        "x": 454.54856932784054,
        "y": 291.65950639194136
    },
    {
        "x": 455.64917119061977,
        "y": 291.65950639194136
    },
    {
        "x": 455.64917119061977,
        "y": 290.5589044810284
    },
    {
        "x": 456.74977305339905,
        "y": 290.5589044810284
    },
    {
        "x": 457.85037491617834,
        "y": 289.4583025701154
    },
    {
        "x": 457.85037491617834,
        "y": 288.3577006592024
    },
    {
        "x": 457.85037491617834,
        "y": 287.2570987482894
    },
    {
        "x": 457.85037491617834,
        "y": 287.2570987482894
    },
    {
        "x": 458.9509767789576,
        "y": 286.15649683737644
    },
    {
        "x": 460.0515786417369,
        "y": 286.15649683737644
    },
    {
        "x": 460.0515786417369,
        "y": 285.05589492646345
    },
    {
        "x": 461.15218050451614,
        "y": 283.95529301555047
    },
    {
        "x": 462.2527823672954,
        "y": 283.95529301555047
    },
    {
        "x": 462.2527823672954,
        "y": 282.8546911046375
    },
    {
        "x": 462.2527823672954,
        "y": 282.8546911046375
    },
    {
        "x": 462.2527823672954,
        "y": 281.7540891937245
    },
    {
        "x": 462.2527823672954,
        "y": 282.8546911046375
    },
    {
        "x": 462.2527823672954,
        "y": 282.8546911046375
    },
    {
        "x": 462.2527823672954,
        "y": 283.95529301555047
    },
    {
        "x": 462.2527823672954,
        "y": 285.05589492646345
    },
    {
        "x": 462.2527823672954,
        "y": 286.15649683737644
    },
    {
        "x": 462.2527823672954,
        "y": 287.2570987482894
    },
    {
        "x": 462.2527823672954,
        "y": 287.2570987482894
    },
    {
        "x": 462.2527823672954,
        "y": 288.3577006592024
    },
    {
        "x": 462.2527823672954,
        "y": 289.4583025701154
    },
    {
        "x": 463.3533842300747,
        "y": 290.5589044810284
    },
    {
        "x": 463.3533842300747,
        "y": 291.65950639194136
    },
    {
        "x": 463.3533842300747,
        "y": 291.65950639194136
    },
    {
        "x": 463.3533842300747,
        "y": 292.76010830285435
    },
    {
        "x": 464.453986092854,
        "y": 293.86071021376733
    },
    {
        "x": 464.453986092854,
        "y": 294.9613121246803
    },
    {
        "x": 464.453986092854,
        "y": 296.0619140355933
    },
    {
        "x": 464.453986092854,
        "y": 296.0619140355933
    },
    {
        "x": 464.453986092854,
        "y": 297.1625159465063
    },
    {
        "x": 464.453986092854,
        "y": 298.2631178574193
    },
    {
        "x": 464.453986092854,
        "y": 299.36371976833226
    },
    {
        "x": 464.453986092854,
        "y": 300.46432167924524
    }
],
  "letter_3":[
    {
        "x": 484.26481962288096,
        "y": 224.5227898262492
    },
    {
        "x": 484.26481962288096,
        "y": 225.6233917371622
    },
    {
        "x": 484.26481962288096,
        "y": 228.92519746990115
    },
    {
        "x": 484.26481962288096,
        "y": 230.02579938081414
    },
    {
        "x": 484.26481962288096,
        "y": 231.12640129172712
    },
    {
        "x": 485.3654214856602,
        "y": 233.3276051135531
    },
    {
        "x": 485.3654214856602,
        "y": 235.52880893537906
    },
    {
        "x": 485.3654214856602,
        "y": 238.83061466811802
    },
    {
        "x": 486.4660233484395,
        "y": 241.03181848994402
    },
    {
        "x": 486.4660233484395,
        "y": 242.132420400857
    },
    {
        "x": 486.4660233484395,
        "y": 243.23302231177
    },
    {
        "x": 486.4660233484395,
        "y": 244.33362422268297
    },
    {
        "x": 486.4660233484395,
        "y": 245.43422613359596
    },
    {
        "x": 486.4660233484395,
        "y": 246.53482804450894
    },
    {
        "x": 486.4660233484395,
        "y": 247.63542995542193
    },
    {
        "x": 486.4660233484395,
        "y": 247.63542995542193
    },
    {
        "x": 486.4660233484395,
        "y": 248.7360318663349
    },
    {
        "x": 486.4660233484395,
        "y": 249.8366337772479
    },
    {
        "x": 486.4660233484395,
        "y": 250.93723568816088
    },
    {
        "x": 486.4660233484395,
        "y": 252.03783759907387
    },
    {
        "x": 486.4660233484395,
        "y": 252.03783759907387
    },
    {
        "x": 486.4660233484395,
        "y": 253.13843950998685
    },
    {
        "x": 486.4660233484395,
        "y": 254.23904142089984
    },
    {
        "x": 486.4660233484395,
        "y": 255.33964333181282
    },
    {
        "x": 486.4660233484395,
        "y": 256.44024524272584
    },
    {
        "x": 486.4660233484395,
        "y": 256.44024524272584
    },
    {
        "x": 486.4660233484395,
        "y": 259.7420509754648
    },
    {
        "x": 486.4660233484395,
        "y": 260.8426528863778
    },
    {
        "x": 486.4660233484395,
        "y": 261.94325479729076
    },
    {
        "x": 486.4660233484395,
        "y": 263.04385670820375
    },
    {
        "x": 486.4660233484395,
        "y": 264.14445861911673
    },
    {
        "x": 486.4660233484395,
        "y": 265.2450605300297
    },
    {
        "x": 486.4660233484395,
        "y": 265.2450605300297
    },
    {
        "x": 486.4660233484395,
        "y": 266.3456624409427
    },
    {
        "x": 486.4660233484395,
        "y": 267.4462643518557
    },
    {
        "x": 486.4660233484395,
        "y": 268.5468662627687
    },
    {
        "x": 486.4660233484395,
        "y": 269.64746817368166
    },
    {
        "x": 486.4660233484395,
        "y": 269.64746817368166
    },
    {
        "x": 486.4660233484395,
        "y": 270.74807008459464
    },
    {
        "x": 486.4660233484395,
        "y": 271.84867199550763
    },
    {
        "x": 486.4660233484395,
        "y": 272.9492739064206
    },
    {
        "x": 486.4660233484395,
        "y": 274.0498758173336
    },
    {
        "x": 486.4660233484395,
        "y": 274.0498758173336
    },
    {
        "x": 487.56662521121876,
        "y": 275.1504777282466
    },
    {
        "x": 487.56662521121876,
        "y": 276.25107963915957
    },
    {
        "x": 488.66722707399805,
        "y": 277.35168155007256
    },
    {
        "x": 488.66722707399805,
        "y": 279.5528853718985
    },
    {
        "x": 488.66722707399805,
        "y": 280.6534872828115
    },
    {
        "x": 488.66722707399805,
        "y": 281.7540891937245
    },
    {
        "x": 488.66722707399805,
        "y": 282.8546911046375
    },
    {
        "x": 488.66722707399805,
        "y": 282.8546911046375
    },
    {
        "x": 488.66722707399805,
        "y": 285.05589492646345
    },
    {
        "x": 488.66722707399805,
        "y": 286.15649683737644
    },
    {
        "x": 488.66722707399805,
        "y": 287.2570987482894
    },
    {
        "x": 488.66722707399805,
        "y": 287.2570987482894
    },
    {
        "x": 488.66722707399805,
        "y": 289.4583025701154
    },
    {
        "x": 488.66722707399805,
        "y": 290.5589044810284
    },
    {
        "x": 488.66722707399805,
        "y": 291.65950639194136
    },
    {
        "x": 488.66722707399805,
        "y": 291.65950639194136
    },
    {
        "x": 488.66722707399805,
        "y": 292.76010830285435
    },
    {
        "x": 488.66722707399805,
        "y": 293.86071021376733
    },
    {
        "x": 488.66722707399805,
        "y": 291.65950639194136
    },
    {
        "x": 488.66722707399805,
        "y": 290.5589044810284
    },
    {
        "x": 487.56662521121876,
        "y": 290.5589044810284
    },
    {
        "x": 487.56662521121876,
        "y": 289.4583025701154
    },
    {
        "x": 487.56662521121876,
        "y": 288.3577006592024
    },
    {
        "x": 487.56662521121876,
        "y": 287.2570987482894
    },
    {
        "x": 487.56662521121876,
        "y": 287.2570987482894
    },
    {
        "x": 487.56662521121876,
        "y": 286.15649683737644
    },
    {
        "x": 487.56662521121876,
        "y": 285.05589492646345
    },
    {
        "x": 487.56662521121876,
        "y": 283.95529301555047
    },
    {
        "x": 487.56662521121876,
        "y": 282.8546911046375
    },
    {
        "x": 487.56662521121876,
        "y": 281.7540891937245
    },
    {
        "x": 487.56662521121876,
        "y": 280.6534872828115
    },
    {
        "x": 487.56662521121876,
        "y": 279.5528853718985
    },
    {
        "x": 487.56662521121876,
        "y": 278.45228346098554
    },
    {
        "x": 487.56662521121876,
        "y": 278.45228346098554
    },
    {
        "x": 487.56662521121876,
        "y": 277.35168155007256
    },
    {
        "x": 487.56662521121876,
        "y": 276.25107963915957
    },
    {
        "x": 487.56662521121876,
        "y": 275.1504777282466
    },
    {
        "x": 487.56662521121876,
        "y": 274.0498758173336
    },
    {
        "x": 487.56662521121876,
        "y": 274.0498758173336
    },
    {
        "x": 487.56662521121876,
        "y": 272.9492739064206
    },
    {
        "x": 487.56662521121876,
        "y": 271.84867199550763
    },
    {
        "x": 487.56662521121876,
        "y": 270.74807008459464
    },
    {
        "x": 488.66722707399805,
        "y": 269.64746817368166
    },
    {
        "x": 488.66722707399805,
        "y": 269.64746817368166
    },
    {
        "x": 488.66722707399805,
        "y": 269.64746817368166
    },
    {
        "x": 488.66722707399805,
        "y": 268.5468662627687
    },
    {
        "x": 489.76782893677733,
        "y": 267.4462643518557
    },
    {
        "x": 490.86843079955656,
        "y": 266.3456624409427
    },
    {
        "x": 490.86843079955656,
        "y": 265.2450605300297
    },
    {
        "x": 491.96903266233585,
        "y": 264.14445861911673
    },
    {
        "x": 493.06963452511513,
        "y": 264.14445861911673
    },
    {
        "x": 493.06963452511513,
        "y": 264.14445861911673
    },
    {
        "x": 493.06963452511513,
        "y": 263.04385670820375
    },
    {
        "x": 494.1702363878944,
        "y": 263.04385670820375
    },
    {
        "x": 495.2708382506737,
        "y": 260.8426528863778
    },
    {
        "x": 496.37144011345293,
        "y": 260.8426528863778
    },
    {
        "x": 497.4720419762322,
        "y": 260.8426528863778
    },
    {
        "x": 497.4720419762322,
        "y": 260.8426528863778
    },
    {
        "x": 498.5726438390115,
        "y": 259.7420509754648
    },
    {
        "x": 499.6732457017908,
        "y": 259.7420509754648
    },
    {
        "x": 499.6732457017908,
        "y": 258.6414490645518
    },
    {
        "x": 501.8744494273493,
        "y": 257.5408471536388
    },
    {
        "x": 501.8744494273493,
        "y": 256.44024524272584
    },
    {
        "x": 501.8744494273493,
        "y": 256.44024524272584
    },
    {
        "x": 502.9750512901286,
        "y": 256.44024524272584
    },
    {
        "x": 504.0756531529079,
        "y": 255.33964333181282
    },
    {
        "x": 505.17625501568716,
        "y": 255.33964333181282
    },
    {
        "x": 506.27685687846645,
        "y": 254.23904142089984
    },
    {
        "x": 506.27685687846645,
        "y": 253.13843950998685
    },
    {
        "x": 506.27685687846645,
        "y": 253.13843950998685
    },
    {
        "x": 507.37745874124573,
        "y": 253.13843950998685
    },
    {
        "x": 508.47806060402496,
        "y": 252.03783759907387
    },
    {
        "x": 508.47806060402496,
        "y": 252.03783759907387
    },
    {
        "x": 508.47806060402496,
        "y": 250.93723568816088
    },
    {
        "x": 509.57866246680425,
        "y": 250.93723568816088
    },
    {
        "x": 510.67926432958353,
        "y": 249.8366337772479
    },
    {
        "x": 510.67926432958353,
        "y": 248.7360318663349
    },
    {
        "x": 510.67926432958353,
        "y": 247.63542995542193
    },
    {
        "x": 511.7798661923628,
        "y": 247.63542995542193
    },
    {
        "x": 512.880468055142,
        "y": 246.53482804450894
    },
    {
        "x": 513.9810699179213,
        "y": 245.43422613359596
    },
    {
        "x": 515.0816717807006,
        "y": 244.33362422268297
    },
    {
        "x": 515.0816717807006,
        "y": 243.23302231177
    },
    {
        "x": 515.0816717807006,
        "y": 243.23302231177
    },
    {
        "x": 516.1822736434799,
        "y": 242.132420400857
    },
    {
        "x": 517.2828755062592,
        "y": 242.132420400857
    },
    {
        "x": 517.2828755062592,
        "y": 241.03181848994402
    },
    {
        "x": 517.2828755062592,
        "y": 239.93121657903103
    },
    {
        "x": 519.4840792318178,
        "y": 239.93121657903103
    },
    {
        "x": 519.4840792318178,
        "y": 238.83061466811802
    },
    {
        "x": 519.4840792318178,
        "y": 239.93121657903103
    },
    {
        "x": 518.3834773690385,
        "y": 241.03181848994402
    },
    {
        "x": 518.3834773690385,
        "y": 242.132420400857
    },
    {
        "x": 518.3834773690385,
        "y": 243.23302231177
    },
    {
        "x": 517.2828755062592,
        "y": 243.23302231177
    },
    {
        "x": 516.1822736434799,
        "y": 243.23302231177
    },
    {
        "x": 516.1822736434799,
        "y": 244.33362422268297
    },
    {
        "x": 515.0816717807006,
        "y": 245.43422613359596
    },
    {
        "x": 513.9810699179213,
        "y": 247.63542995542193
    },
    {
        "x": 513.9810699179213,
        "y": 247.63542995542193
    },
    {
        "x": 511.7798661923628,
        "y": 249.8366337772479
    },
    {
        "x": 510.67926432958353,
        "y": 250.93723568816088
    },
    {
        "x": 510.67926432958353,
        "y": 252.03783759907387
    },
    {
        "x": 510.67926432958353,
        "y": 252.03783759907387
    },
    {
        "x": 510.67926432958353,
        "y": 252.03783759907387
    },
    {
        "x": 510.67926432958353,
        "y": 253.13843950998685
    },
    {
        "x": 509.57866246680425,
        "y": 254.23904142089984
    },
    {
        "x": 509.57866246680425,
        "y": 255.33964333181282
    },
    {
        "x": 508.47806060402496,
        "y": 255.33964333181282
    },
    {
        "x": 508.47806060402496,
        "y": 256.44024524272584
    },
    {
        "x": 507.37745874124573,
        "y": 256.44024524272584
    },
    {
        "x": 507.37745874124573,
        "y": 256.44024524272584
    },
    {
        "x": 506.27685687846645,
        "y": 257.5408471536388
    },
    {
        "x": 506.27685687846645,
        "y": 258.6414490645518
    },
    {
        "x": 506.27685687846645,
        "y": 258.6414490645518
    },
    {
        "x": 505.17625501568716,
        "y": 259.7420509754648
    },
    {
        "x": 505.17625501568716,
        "y": 260.8426528863778
    },
    {
        "x": 504.0756531529079,
        "y": 260.8426528863778
    },
    {
        "x": 502.9750512901286,
        "y": 260.8426528863778
    },
    {
        "x": 501.8744494273493,
        "y": 264.14445861911673
    },
    {
        "x": 501.8744494273493,
        "y": 264.14445861911673
    },
    {
        "x": 501.8744494273493,
        "y": 265.2450605300297
    },
    {
        "x": 501.8744494273493,
        "y": 265.2450605300297
    },
    {
        "x": 501.8744494273493,
        "y": 267.4462643518557
    },
    {
        "x": 502.9750512901286,
        "y": 269.64746817368166
    },
    {
        "x": 504.0756531529079,
        "y": 269.64746817368166
    },
    {
        "x": 505.17625501568716,
        "y": 270.74807008459464
    },
    {
        "x": 505.17625501568716,
        "y": 271.84867199550763
    },
    {
        "x": 506.27685687846645,
        "y": 272.9492739064206
    },
    {
        "x": 506.27685687846645,
        "y": 274.0498758173336
    },
    {
        "x": 506.27685687846645,
        "y": 274.0498758173336
    },
    {
        "x": 507.37745874124573,
        "y": 275.1504777282466
    },
    {
        "x": 508.47806060402496,
        "y": 275.1504777282466
    },
    {
        "x": 508.47806060402496,
        "y": 276.25107963915957
    },
    {
        "x": 509.57866246680425,
        "y": 276.25107963915957
    },
    {
        "x": 509.57866246680425,
        "y": 277.35168155007256
    },
    {
        "x": 510.67926432958353,
        "y": 278.45228346098554
    },
    {
        "x": 510.67926432958353,
        "y": 278.45228346098554
    },
    {
        "x": 510.67926432958353,
        "y": 278.45228346098554
    },
    {
        "x": 510.67926432958353,
        "y": 279.5528853718985
    },
    {
        "x": 510.67926432958353,
        "y": 280.6534872828115
    },
    {
        "x": 512.880468055142,
        "y": 280.6534872828115
    },
    {
        "x": 513.9810699179213,
        "y": 282.8546911046375
    },
    {
        "x": 513.9810699179213,
        "y": 282.8546911046375
    },
    {
        "x": 515.0816717807006,
        "y": 282.8546911046375
    },
    {
        "x": 515.0816717807006,
        "y": 283.95529301555047
    },
    {
        "x": 515.0816717807006,
        "y": 283.95529301555047
    },
    {
        "x": 515.0816717807006,
        "y": 285.05589492646345
    },
    {
        "x": 515.0816717807006,
        "y": 286.15649683737644
    },
    {
        "x": 516.1822736434799,
        "y": 287.2570987482894
    },
    {
        "x": 517.2828755062592,
        "y": 287.2570987482894
    },
    {
        "x": 518.3834773690385,
        "y": 287.2570987482894
    },
    {
        "x": 519.4840792318178,
        "y": 287.2570987482894
    },
    {
        "x": 519.4840792318178,
        "y": 287.2570987482894
    },
    {
        "x": 520.584681094597,
        "y": 288.3577006592024
    },
    {
        "x": 521.6852829573763,
        "y": 288.3577006592024
    },
    {
        "x": 522.7858848201555,
        "y": 288.3577006592024
    },
    {
        "x": 522.7858848201555,
        "y": 289.4583025701154
    },
    {
        "x": 523.8864866829348,
        "y": 289.4583025701154
    },
    {
        "x": 523.8864866829348,
        "y": 290.5589044810284
    }
],
  "letter_4":[
    {
        "x": 537.0937090362861,
        "y": 260.8426528863778
    },
    {
        "x": 537.0937090362861,
        "y": 260.8426528863778
    },
    {
        "x": 538.1943108990654,
        "y": 260.8426528863778
    },
    {
        "x": 539.2949127618447,
        "y": 260.8426528863778
    },
    {
        "x": 541.4961164874032,
        "y": 260.8426528863778
    },
    {
        "x": 541.4961164874032,
        "y": 260.8426528863778
    },
    {
        "x": 542.5967183501825,
        "y": 260.8426528863778
    },
    {
        "x": 543.6973202129618,
        "y": 260.8426528863778
    },
    {
        "x": 544.7979220757411,
        "y": 260.8426528863778
    },
    {
        "x": 545.8985239385204,
        "y": 260.8426528863778
    },
    {
        "x": 545.8985239385204,
        "y": 260.8426528863778
    },
    {
        "x": 546.9991258012996,
        "y": 260.8426528863778
    },
    {
        "x": 548.0997276640788,
        "y": 260.8426528863778
    },
    {
        "x": 549.2003295268581,
        "y": 260.8426528863778
    },
    {
        "x": 550.3009313896374,
        "y": 260.8426528863778
    },
    {
        "x": 550.3009313896374,
        "y": 260.8426528863778
    },
    {
        "x": 551.4015332524167,
        "y": 260.8426528863778
    },
    {
        "x": 552.502135115196,
        "y": 260.8426528863778
    },
    {
        "x": 553.6027369779753,
        "y": 260.8426528863778
    },
    {
        "x": 554.7033388407546,
        "y": 260.8426528863778
    },
    {
        "x": 555.8039407035338,
        "y": 260.8426528863778
    },
    {
        "x": 556.9045425663131,
        "y": 260.8426528863778
    },
    {
        "x": 556.9045425663131,
        "y": 260.8426528863778
    },
    {
        "x": 559.1057462918716,
        "y": 259.7420509754648
    },
    {
        "x": 559.1057462918716,
        "y": 259.7420509754648
    },
    {
        "x": 561.3069500174302,
        "y": 259.7420509754648
    },
    {
        "x": 563.5081537429887,
        "y": 259.7420509754648
    },
    {
        "x": 563.5081537429887,
        "y": 259.7420509754648
    },
    {
        "x": 565.7093574685473,
        "y": 259.7420509754648
    },
    {
        "x": 566.8099593313266,
        "y": 258.6414490645518
    },
    {
        "x": 567.9105611941059,
        "y": 258.6414490645518
    },
    {
        "x": 567.9105611941059,
        "y": 258.6414490645518
    },
    {
        "x": 569.0111630568852,
        "y": 258.6414490645518
    },
    {
        "x": 571.2123667824436,
        "y": 257.5408471536388
    },
    {
        "x": 572.3129686452229,
        "y": 257.5408471536388
    },
    {
        "x": 572.3129686452229,
        "y": 256.44024524272584
    },
    {
        "x": 573.4135705080022,
        "y": 256.44024524272584
    },
    {
        "x": 574.5141723707815,
        "y": 256.44024524272584
    },
    {
        "x": 576.71537609634,
        "y": 256.44024524272584
    },
    {
        "x": 576.71537609634,
        "y": 256.44024524272584
    },
    {
        "x": 577.8159779591193,
        "y": 256.44024524272584
    },
    {
        "x": 578.9165798218986,
        "y": 256.44024524272584
    },
    {
        "x": 580.0171816846779,
        "y": 256.44024524272584
    },
    {
        "x": 581.1177835474571,
        "y": 256.44024524272584
    },
    {
        "x": 580.0171816846779,
        "y": 255.33964333181282
    },
    {
        "x": 577.8159779591193,
        "y": 254.23904142089984
    },
    {
        "x": 576.71537609634,
        "y": 254.23904142089984
    },
    {
        "x": 576.71537609634,
        "y": 253.13843950998685
    },
    {
        "x": 576.71537609634,
        "y": 252.03783759907387
    },
    {
        "x": 576.71537609634,
        "y": 252.03783759907387
    },
    {
        "x": 574.5141723707815,
        "y": 252.03783759907387
    },
    {
        "x": 574.5141723707815,
        "y": 250.93723568816088
    },
    {
        "x": 573.4135705080022,
        "y": 250.93723568816088
    },
    {
        "x": 573.4135705080022,
        "y": 249.8366337772479
    },
    {
        "x": 572.3129686452229,
        "y": 249.8366337772479
    },
    {
        "x": 572.3129686452229,
        "y": 248.7360318663349
    },
    {
        "x": 571.2123667824436,
        "y": 248.7360318663349
    },
    {
        "x": 570.1117649196643,
        "y": 247.63542995542193
    },
    {
        "x": 569.0111630568852,
        "y": 247.63542995542193
    },
    {
        "x": 567.9105611941059,
        "y": 247.63542995542193
    },
    {
        "x": 567.9105611941059,
        "y": 246.53482804450894
    },
    {
        "x": 565.7093574685473,
        "y": 245.43422613359596
    },
    {
        "x": 565.7093574685473,
        "y": 244.33362422268297
    },
    {
        "x": 564.608755605768,
        "y": 244.33362422268297
    },
    {
        "x": 563.5081537429887,
        "y": 244.33362422268297
    },
    {
        "x": 563.5081537429887,
        "y": 243.23302231177
    },
    {
        "x": 563.5081537429887,
        "y": 243.23302231177
    },
    {
        "x": 562.4075518802094,
        "y": 243.23302231177
    },
    {
        "x": 561.3069500174302,
        "y": 242.132420400857
    },
    {
        "x": 560.2063481546509,
        "y": 242.132420400857
    },
    {
        "x": 559.1057462918716,
        "y": 242.132420400857
    },
    {
        "x": 559.1057462918716,
        "y": 241.03181848994402
    },
    {
        "x": 559.1057462918716,
        "y": 241.03181848994402
    },
    {
        "x": 556.9045425663131,
        "y": 241.03181848994402
    },
    {
        "x": 556.9045425663131,
        "y": 239.93121657903103
    },
    {
        "x": 554.7033388407546,
        "y": 239.93121657903103
    },
    {
        "x": 554.7033388407546,
        "y": 239.93121657903103
    },
    {
        "x": 553.6027369779753,
        "y": 239.93121657903103
    },
    {
        "x": 552.502135115196,
        "y": 239.93121657903103
    },
    {
        "x": 551.4015332524167,
        "y": 239.93121657903103
    },
    {
        "x": 550.3009313896374,
        "y": 239.93121657903103
    },
    {
        "x": 550.3009313896374,
        "y": 239.93121657903103
    },
    {
        "x": 549.2003295268581,
        "y": 239.93121657903103
    },
    {
        "x": 548.0997276640788,
        "y": 239.93121657903103
    },
    {
        "x": 545.8985239385204,
        "y": 239.93121657903103
    },
    {
        "x": 545.8985239385204,
        "y": 239.93121657903103
    },
    {
        "x": 545.8985239385204,
        "y": 241.03181848994402
    },
    {
        "x": 544.7979220757411,
        "y": 241.03181848994402
    },
    {
        "x": 543.6973202129618,
        "y": 241.03181848994402
    },
    {
        "x": 543.6973202129618,
        "y": 242.132420400857
    },
    {
        "x": 542.5967183501825,
        "y": 243.23302231177
    },
    {
        "x": 541.4961164874032,
        "y": 243.23302231177
    },
    {
        "x": 541.4961164874032,
        "y": 244.33362422268297
    },
    {
        "x": 541.4961164874032,
        "y": 245.43422613359596
    },
    {
        "x": 541.4961164874032,
        "y": 246.53482804450894
    },
    {
        "x": 540.395514624624,
        "y": 247.63542995542193
    },
    {
        "x": 540.395514624624,
        "y": 247.63542995542193
    },
    {
        "x": 539.2949127618447,
        "y": 248.7360318663349
    },
    {
        "x": 539.2949127618447,
        "y": 249.8366337772479
    },
    {
        "x": 539.2949127618447,
        "y": 252.03783759907387
    },
    {
        "x": 539.2949127618447,
        "y": 252.03783759907387
    },
    {
        "x": 539.2949127618447,
        "y": 253.13843950998685
    },
    {
        "x": 539.2949127618447,
        "y": 254.23904142089984
    },
    {
        "x": 539.2949127618447,
        "y": 255.33964333181282
    },
    {
        "x": 539.2949127618447,
        "y": 256.44024524272584
    },
    {
        "x": 539.2949127618447,
        "y": 257.5408471536388
    },
    {
        "x": 539.2949127618447,
        "y": 258.6414490645518
    },
    {
        "x": 539.2949127618447,
        "y": 259.7420509754648
    },
    {
        "x": 539.2949127618447,
        "y": 260.8426528863778
    },
    {
        "x": 539.2949127618447,
        "y": 260.8426528863778
    },
    {
        "x": 539.2949127618447,
        "y": 261.94325479729076
    },
    {
        "x": 539.2949127618447,
        "y": 263.04385670820375
    },
    {
        "x": 539.2949127618447,
        "y": 264.14445861911673
    },
    {
        "x": 539.2949127618447,
        "y": 265.2450605300297
    },
    {
        "x": 539.2949127618447,
        "y": 266.3456624409427
    },
    {
        "x": 539.2949127618447,
        "y": 267.4462643518557
    },
    {
        "x": 539.2949127618447,
        "y": 268.5468662627687
    },
    {
        "x": 539.2949127618447,
        "y": 269.64746817368166
    },
    {
        "x": 540.395514624624,
        "y": 269.64746817368166
    },
    {
        "x": 540.395514624624,
        "y": 270.74807008459464
    },
    {
        "x": 540.395514624624,
        "y": 271.84867199550763
    },
    {
        "x": 541.4961164874032,
        "y": 271.84867199550763
    },
    {
        "x": 541.4961164874032,
        "y": 272.9492739064206
    },
    {
        "x": 541.4961164874032,
        "y": 274.0498758173336
    },
    {
        "x": 542.5967183501825,
        "y": 274.0498758173336
    },
    {
        "x": 542.5967183501825,
        "y": 274.0498758173336
    },
    {
        "x": 542.5967183501825,
        "y": 275.1504777282466
    },
    {
        "x": 542.5967183501825,
        "y": 276.25107963915957
    },
    {
        "x": 543.6973202129618,
        "y": 276.25107963915957
    },
    {
        "x": 544.7979220757411,
        "y": 277.35168155007256
    },
    {
        "x": 545.8985239385204,
        "y": 278.45228346098554
    },
    {
        "x": 545.8985239385204,
        "y": 278.45228346098554
    },
    {
        "x": 546.9991258012996,
        "y": 279.5528853718985
    },
    {
        "x": 548.0997276640788,
        "y": 280.6534872828115
    },
    {
        "x": 549.2003295268581,
        "y": 280.6534872828115
    },
    {
        "x": 549.2003295268581,
        "y": 281.7540891937245
    },
    {
        "x": 550.3009313896374,
        "y": 281.7540891937245
    },
    {
        "x": 550.3009313896374,
        "y": 282.8546911046375
    },
    {
        "x": 551.4015332524167,
        "y": 282.8546911046375
    },
    {
        "x": 553.6027369779753,
        "y": 282.8546911046375
    },
    {
        "x": 554.7033388407546,
        "y": 283.95529301555047
    },
    {
        "x": 554.7033388407546,
        "y": 283.95529301555047
    },
    {
        "x": 555.8039407035338,
        "y": 283.95529301555047
    },
    {
        "x": 556.9045425663131,
        "y": 285.05589492646345
    },
    {
        "x": 558.0051444290923,
        "y": 285.05589492646345
    },
    {
        "x": 559.1057462918716,
        "y": 285.05589492646345
    },
    {
        "x": 559.1057462918716,
        "y": 285.05589492646345
    },
    {
        "x": 560.2063481546509,
        "y": 285.05589492646345
    },
    {
        "x": 561.3069500174302,
        "y": 285.05589492646345
    },
    {
        "x": 562.4075518802094,
        "y": 285.05589492646345
    },
    {
        "x": 563.5081537429887,
        "y": 285.05589492646345
    },
    {
        "x": 564.608755605768,
        "y": 285.05589492646345
    },
    {
        "x": 565.7093574685473,
        "y": 285.05589492646345
    },
    {
        "x": 566.8099593313266,
        "y": 285.05589492646345
    },
    {
        "x": 566.8099593313266,
        "y": 283.95529301555047
    },
    {
        "x": 566.8099593313266,
        "y": 282.8546911046375
    },
    {
        "x": 567.9105611941059,
        "y": 282.8546911046375
    },
    {
        "x": 567.9105611941059,
        "y": 282.8546911046375
    },
    {
        "x": 567.9105611941059,
        "y": 282.8546911046375
    },
    {
        "x": 569.0111630568852,
        "y": 281.7540891937245
    },
    {
        "x": 570.1117649196643,
        "y": 281.7540891937245
    },
    {
        "x": 570.1117649196643,
        "y": 280.6534872828115
    },
    {
        "x": 571.2123667824436,
        "y": 279.5528853718985
    },
    {
        "x": 571.2123667824436,
        "y": 278.45228346098554
    },
    {
        "x": 572.3129686452229,
        "y": 278.45228346098554
    },
    {
        "x": 572.3129686452229,
        "y": 278.45228346098554
    },
    {
        "x": 573.4135705080022,
        "y": 278.45228346098554
    },
    {
        "x": 574.5141723707815,
        "y": 278.45228346098554
    },
    {
        "x": 574.5141723707815,
        "y": 278.45228346098554
    },
    {
        "x": 575.6147742335608,
        "y": 277.35168155007256
    },
    {
        "x": 575.6147742335608,
        "y": 276.25107963915957
    },
    {
        "x": 576.71537609634,
        "y": 275.1504777282466
    },
    {
        "x": 576.71537609634,
        "y": 274.0498758173336
    },
    {
        "x": 576.71537609634,
        "y": 274.0498758173336
    },
    {
        "x": 577.8159779591193,
        "y": 274.0498758173336
    }
],
  "letter_5":[
    {
        "x": 697.7815810020603,
        "y": 230.02579938081414
    },
    {
        "x": 697.7815810020603,
        "y": 231.12640129172712
    },
    {
        "x": 697.7815810020603,
        "y": 232.2270032026401
    },
    {
        "x": 697.7815810020603,
        "y": 233.3276051135531
    },
    {
        "x": 697.7815810020603,
        "y": 234.42820702446608
    },
    {
        "x": 697.7815810020603,
        "y": 234.42820702446608
    },
    {
        "x": 697.7815810020603,
        "y": 235.52880893537906
    },
    {
        "x": 697.7815810020603,
        "y": 236.62941084629205
    },
    {
        "x": 697.7815810020603,
        "y": 237.73001275720503
    },
    {
        "x": 697.7815810020603,
        "y": 238.83061466811802
    },
    {
        "x": 697.7815810020603,
        "y": 238.83061466811802
    },
    {
        "x": 697.7815810020603,
        "y": 239.93121657903103
    },
    {
        "x": 697.7815810020603,
        "y": 241.03181848994402
    },
    {
        "x": 697.7815810020603,
        "y": 242.132420400857
    },
    {
        "x": 697.7815810020603,
        "y": 243.23302231177
    },
    {
        "x": 697.7815810020603,
        "y": 243.23302231177
    },
    {
        "x": 697.7815810020603,
        "y": 244.33362422268297
    },
    {
        "x": 697.7815810020603,
        "y": 245.43422613359596
    },
    {
        "x": 697.7815810020603,
        "y": 246.53482804450894
    },
    {
        "x": 697.7815810020603,
        "y": 247.63542995542193
    },
    {
        "x": 697.7815810020603,
        "y": 247.63542995542193
    },
    {
        "x": 697.7815810020603,
        "y": 248.7360318663349
    },
    {
        "x": 697.7815810020603,
        "y": 249.8366337772479
    },
    {
        "x": 697.7815810020603,
        "y": 250.93723568816088
    },
    {
        "x": 697.7815810020603,
        "y": 252.03783759907387
    },
    {
        "x": 695.5803772765017,
        "y": 250.93723568816088
    },
    {
        "x": 695.5803772765017,
        "y": 248.7360318663349
    },
    {
        "x": 695.5803772765017,
        "y": 247.63542995542193
    },
    {
        "x": 694.4797754137225,
        "y": 247.63542995542193
    },
    {
        "x": 694.4797754137225,
        "y": 247.63542995542193
    },
    {
        "x": 694.4797754137225,
        "y": 246.53482804450894
    },
    {
        "x": 693.3791735509432,
        "y": 246.53482804450894
    },
    {
        "x": 692.2785716881639,
        "y": 245.43422613359596
    },
    {
        "x": 692.2785716881639,
        "y": 244.33362422268297
    },
    {
        "x": 691.1779698253846,
        "y": 243.23302231177
    },
    {
        "x": 691.1779698253846,
        "y": 243.23302231177
    },
    {
        "x": 691.1779698253846,
        "y": 242.132420400857
    },
    {
        "x": 691.1779698253846,
        "y": 242.132420400857
    },
    {
        "x": 690.0773679626053,
        "y": 241.03181848994402
    },
    {
        "x": 690.0773679626053,
        "y": 239.93121657903103
    },
    {
        "x": 690.0773679626053,
        "y": 238.83061466811802
    },
    {
        "x": 688.976766099826,
        "y": 238.83061466811802
    },
    {
        "x": 687.8761642370467,
        "y": 237.73001275720503
    },
    {
        "x": 686.7755623742676,
        "y": 236.62941084629205
    },
    {
        "x": 686.7755623742676,
        "y": 236.62941084629205
    },
    {
        "x": 685.6749605114883,
        "y": 236.62941084629205
    },
    {
        "x": 684.574358648709,
        "y": 235.52880893537906
    },
    {
        "x": 683.4737567859297,
        "y": 235.52880893537906
    },
    {
        "x": 682.3731549231504,
        "y": 235.52880893537906
    },
    {
        "x": 682.3731549231504,
        "y": 234.42820702446608
    },
    {
        "x": 681.2725530603711,
        "y": 234.42820702446608
    },
    {
        "x": 680.1719511975919,
        "y": 234.42820702446608
    },
    {
        "x": 679.0713493348126,
        "y": 234.42820702446608
    },
    {
        "x": 677.9707474720333,
        "y": 234.42820702446608
    },
    {
        "x": 676.870145609254,
        "y": 234.42820702446608
    },
    {
        "x": 675.7695437464747,
        "y": 234.42820702446608
    },
    {
        "x": 674.6689418836955,
        "y": 234.42820702446608
    },
    {
        "x": 673.5683400209163,
        "y": 234.42820702446608
    },
    {
        "x": 673.5683400209163,
        "y": 234.42820702446608
    },
    {
        "x": 672.467738158137,
        "y": 234.42820702446608
    },
    {
        "x": 671.3671362953577,
        "y": 234.42820702446608
    },
    {
        "x": 670.2665344325784,
        "y": 234.42820702446608
    },
    {
        "x": 669.1659325697991,
        "y": 234.42820702446608
    },
    {
        "x": 669.1659325697991,
        "y": 234.42820702446608
    },
    {
        "x": 668.0653307070198,
        "y": 234.42820702446608
    },
    {
        "x": 666.9647288442405,
        "y": 234.42820702446608
    },
    {
        "x": 664.763525118682,
        "y": 234.42820702446608
    },
    {
        "x": 664.763525118682,
        "y": 235.52880893537906
    },
    {
        "x": 664.763525118682,
        "y": 236.62941084629205
    },
    {
        "x": 664.763525118682,
        "y": 236.62941084629205
    },
    {
        "x": 662.5623213931235,
        "y": 237.73001275720503
    },
    {
        "x": 661.4617195303442,
        "y": 238.83061466811802
    },
    {
        "x": 661.4617195303442,
        "y": 238.83061466811802
    },
    {
        "x": 660.3611176675649,
        "y": 238.83061466811802
    },
    {
        "x": 660.3611176675649,
        "y": 239.93121657903103
    },
    {
        "x": 660.3611176675649,
        "y": 241.03181848994402
    },
    {
        "x": 660.3611176675649,
        "y": 241.03181848994402
    },
    {
        "x": 660.3611176675649,
        "y": 242.132420400857
    },
    {
        "x": 660.3611176675649,
        "y": 243.23302231177
    },
    {
        "x": 660.3611176675649,
        "y": 243.23302231177
    },
    {
        "x": 659.2605158047857,
        "y": 244.33362422268297
    },
    {
        "x": 659.2605158047857,
        "y": 245.43422613359596
    },
    {
        "x": 658.1599139420064,
        "y": 246.53482804450894
    },
    {
        "x": 658.1599139420064,
        "y": 247.63542995542193
    },
    {
        "x": 658.1599139420064,
        "y": 247.63542995542193
    },
    {
        "x": 658.1599139420064,
        "y": 248.7360318663349
    },
    {
        "x": 658.1599139420064,
        "y": 249.8366337772479
    },
    {
        "x": 658.1599139420064,
        "y": 250.93723568816088
    },
    {
        "x": 658.1599139420064,
        "y": 252.03783759907387
    },
    {
        "x": 658.1599139420064,
        "y": 252.03783759907387
    },
    {
        "x": 658.1599139420064,
        "y": 253.13843950998685
    },
    {
        "x": 658.1599139420064,
        "y": 254.23904142089984
    },
    {
        "x": 658.1599139420064,
        "y": 255.33964333181282
    },
    {
        "x": 658.1599139420064,
        "y": 256.44024524272584
    },
    {
        "x": 658.1599139420064,
        "y": 256.44024524272584
    },
    {
        "x": 658.1599139420064,
        "y": 257.5408471536388
    },
    {
        "x": 658.1599139420064,
        "y": 258.6414490645518
    },
    {
        "x": 658.1599139420064,
        "y": 259.7420509754648
    },
    {
        "x": 658.1599139420064,
        "y": 260.8426528863778
    },
    {
        "x": 658.1599139420064,
        "y": 260.8426528863778
    },
    {
        "x": 658.1599139420064,
        "y": 261.94325479729076
    },
    {
        "x": 658.1599139420064,
        "y": 263.04385670820375
    },
    {
        "x": 658.1599139420064,
        "y": 264.14445861911673
    },
    {
        "x": 658.1599139420064,
        "y": 265.2450605300297
    },
    {
        "x": 659.2605158047857,
        "y": 265.2450605300297
    },
    {
        "x": 660.3611176675649,
        "y": 266.3456624409427
    },
    {
        "x": 660.3611176675649,
        "y": 267.4462643518557
    },
    {
        "x": 660.3611176675649,
        "y": 268.5468662627687
    },
    {
        "x": 661.4617195303442,
        "y": 269.64746817368166
    },
    {
        "x": 662.5623213931235,
        "y": 269.64746817368166
    },
    {
        "x": 663.6629232559027,
        "y": 269.64746817368166
    },
    {
        "x": 664.763525118682,
        "y": 270.74807008459464
    },
    {
        "x": 664.763525118682,
        "y": 271.84867199550763
    },
    {
        "x": 665.8641269814613,
        "y": 271.84867199550763
    },
    {
        "x": 665.8641269814613,
        "y": 272.9492739064206
    },
    {
        "x": 666.9647288442405,
        "y": 272.9492739064206
    },
    {
        "x": 666.9647288442405,
        "y": 274.0498758173336
    },
    {
        "x": 668.0653307070198,
        "y": 274.0498758173336
    },
    {
        "x": 669.1659325697991,
        "y": 274.0498758173336
    },
    {
        "x": 669.1659325697991,
        "y": 274.0498758173336
    },
    {
        "x": 669.1659325697991,
        "y": 274.0498758173336
    },
    {
        "x": 670.2665344325784,
        "y": 275.1504777282466
    },
    {
        "x": 671.3671362953577,
        "y": 275.1504777282466
    },
    {
        "x": 672.467738158137,
        "y": 275.1504777282466
    },
    {
        "x": 673.5683400209163,
        "y": 275.1504777282466
    },
    {
        "x": 673.5683400209163,
        "y": 275.1504777282466
    },
    {
        "x": 677.9707474720333,
        "y": 275.1504777282466
    },
    {
        "x": 679.0713493348126,
        "y": 275.1504777282466
    },
    {
        "x": 680.1719511975919,
        "y": 275.1504777282466
    },
    {
        "x": 681.2725530603711,
        "y": 275.1504777282466
    },
    {
        "x": 682.3731549231504,
        "y": 275.1504777282466
    },
    {
        "x": 682.3731549231504,
        "y": 275.1504777282466
    },
    {
        "x": 682.3731549231504,
        "y": 274.0498758173336
    },
    {
        "x": 683.4737567859297,
        "y": 274.0498758173336
    },
    {
        "x": 685.6749605114883,
        "y": 274.0498758173336
    },
    {
        "x": 686.7755623742676,
        "y": 274.0498758173336
    },
    {
        "x": 686.7755623742676,
        "y": 274.0498758173336
    },
    {
        "x": 687.8761642370467,
        "y": 272.9492739064206
    },
    {
        "x": 688.976766099826,
        "y": 271.84867199550763
    },
    {
        "x": 690.0773679626053,
        "y": 271.84867199550763
    },
    {
        "x": 690.0773679626053,
        "y": 270.74807008459464
    },
    {
        "x": 691.1779698253846,
        "y": 269.64746817368166
    },
    {
        "x": 691.1779698253846,
        "y": 269.64746817368166
    },
    {
        "x": 691.1779698253846,
        "y": 268.5468662627687
    },
    {
        "x": 692.2785716881639,
        "y": 267.4462643518557
    },
    {
        "x": 693.3791735509432,
        "y": 267.4462643518557
    },
    {
        "x": 694.4797754137225,
        "y": 266.3456624409427
    },
    {
        "x": 694.4797754137225,
        "y": 265.2450605300297
    },
    {
        "x": 694.4797754137225,
        "y": 265.2450605300297
    },
    {
        "x": 695.5803772765017,
        "y": 264.14445861911673
    },
    {
        "x": 695.5803772765017,
        "y": 263.04385670820375
    },
    {
        "x": 695.5803772765017,
        "y": 261.94325479729076
    },
    {
        "x": 696.680979139281,
        "y": 260.8426528863778
    },
    {
        "x": 696.680979139281,
        "y": 260.8426528863778
    },
    {
        "x": 696.680979139281,
        "y": 259.7420509754648
    },
    {
        "x": 696.680979139281,
        "y": 258.6414490645518
    },
    {
        "x": 696.680979139281,
        "y": 257.5408471536388
    },
    {
        "x": 696.680979139281,
        "y": 256.44024524272584
    },
    {
        "x": 697.7815810020603,
        "y": 256.44024524272584
    },
    {
        "x": 697.7815810020603,
        "y": 255.33964333181282
    },
    {
        "x": 697.7815810020603,
        "y": 254.23904142089984
    },
    {
        "x": 697.7815810020603,
        "y": 256.44024524272584
    },
    {
        "x": 697.7815810020603,
        "y": 256.44024524272584
    },
    {
        "x": 697.7815810020603,
        "y": 258.6414490645518
    },
    {
        "x": 697.7815810020603,
        "y": 259.7420509754648
    },
    {
        "x": 697.7815810020603,
        "y": 260.8426528863778
    },
    {
        "x": 697.7815810020603,
        "y": 260.8426528863778
    },
    {
        "x": 698.8821828648395,
        "y": 264.14445861911673
    },
    {
        "x": 698.8821828648395,
        "y": 265.2450605300297
    },
    {
        "x": 698.8821828648395,
        "y": 265.2450605300297
    },
    {
        "x": 698.8821828648395,
        "y": 266.3456624409427
    },
    {
        "x": 698.8821828648395,
        "y": 267.4462643518557
    },
    {
        "x": 698.8821828648395,
        "y": 268.5468662627687
    },
    {
        "x": 698.8821828648395,
        "y": 269.64746817368166
    },
    {
        "x": 698.8821828648395,
        "y": 269.64746817368166
    },
    {
        "x": 699.9827847276188,
        "y": 270.74807008459464
    },
    {
        "x": 699.9827847276188,
        "y": 271.84867199550763
    },
    {
        "x": 699.9827847276188,
        "y": 272.9492739064206
    },
    {
        "x": 699.9827847276188,
        "y": 274.0498758173336
    },
    {
        "x": 699.9827847276188,
        "y": 274.0498758173336
    },
    {
        "x": 699.9827847276188,
        "y": 275.1504777282466
    },
    {
        "x": 699.9827847276188,
        "y": 276.25107963915957
    },
    {
        "x": 699.9827847276188,
        "y": 277.35168155007256
    },
    {
        "x": 699.9827847276188,
        "y": 278.45228346098554
    },
    {
        "x": 699.9827847276188,
        "y": 278.45228346098554
    },
    {
        "x": 699.9827847276188,
        "y": 279.5528853718985
    }
],
}

export const esTitleLetters = 
{
  "letter_1":[
    {
        "x": 404.3261802575107,
        "y": 265.88841201716735
    },
    {
        "x": 404.3261802575107,
        "y": 269.18454935622316
    },
    {
        "x": 404.3261802575107,
        "y": 273.5793991416309
    },
    {
        "x": 404.3261802575107,
        "y": 277.9742489270386
    },
    {
        "x": 404.3261802575107,
        "y": 280.17167381974247
    },
    {
        "x": 404.3261802575107,
        "y": 281.2703862660944
    },
    {
        "x": 404.3261802575107,
        "y": 282.3690987124464
    },
    {
        "x": 404.3261802575107,
        "y": 285.6652360515021
    },
    {
        "x": 404.3261802575107,
        "y": 286.7639484978541
    },
    {
        "x": 404.3261802575107,
        "y": 288.9613733905579
    },
    {
        "x": 404.3261802575107,
        "y": 290.0600858369099
    },
    {
        "x": 404.3261802575107,
        "y": 291.1587982832618
    },
    {
        "x": 404.3261802575107,
        "y": 294.4549356223176
    },
    {
        "x": 404.3261802575107,
        "y": 296.6523605150215
    },
    {
        "x": 404.3261802575107,
        "y": 297.7510729613734
    },
    {
        "x": 404.3261802575107,
        "y": 299.94849785407723
    },
    {
        "x": 404.3261802575107,
        "y": 301.0472103004292
    },
    {
        "x": 404.3261802575107,
        "y": 304.343347639485
    },
    {
        "x": 404.3261802575107,
        "y": 304.343347639485
    },
    {
        "x": 404.3261802575107,
        "y": 305.4420600858369
    },
    {
        "x": 404.3261802575107,
        "y": 304.343347639485
    },
    {
        "x": 404.3261802575107,
        "y": 297.7510729613734
    },
    {
        "x": 405.42489270386267,
        "y": 293.3562231759657
    },
    {
        "x": 406.52360515021456,
        "y": 291.1587982832618
    },
    {
        "x": 406.52360515021456,
        "y": 285.6652360515021
    },
    {
        "x": 406.52360515021456,
        "y": 284.5665236051502
    },
    {
        "x": 407.6223175965665,
        "y": 282.3690987124464
    },
    {
        "x": 408.72103004291847,
        "y": 282.3690987124464
    },
    {
        "x": 408.72103004291847,
        "y": 281.2703862660944
    },
    {
        "x": 408.72103004291847,
        "y": 280.17167381974247
    },
    {
        "x": 408.72103004291847,
        "y": 280.17167381974247
    },
    {
        "x": 409.81974248927037,
        "y": 279.07296137339057
    },
    {
        "x": 412.0171673819743,
        "y": 277.9742489270386
    },
    {
        "x": 413.1158798283262,
        "y": 276.8755364806867
    },
    {
        "x": 414.2145922746781,
        "y": 276.8755364806867
    },
    {
        "x": 415.31330472103,
        "y": 273.5793991416309
    },
    {
        "x": 416.412017167382,
        "y": 273.5793991416309
    },
    {
        "x": 416.412017167382,
        "y": 273.5793991416309
    },
    {
        "x": 417.51072961373393,
        "y": 273.5793991416309
    },
    {
        "x": 418.6094420600858,
        "y": 273.5793991416309
    },
    {
        "x": 419.7081545064378,
        "y": 273.5793991416309
    },
    {
        "x": 420.8068669527897,
        "y": 273.5793991416309
    },
    {
        "x": 421.90557939914163,
        "y": 274.6781115879828
    },
    {
        "x": 424.1030042918455,
        "y": 276.8755364806867
    },
    {
        "x": 425.20171673819743,
        "y": 277.9742489270386
    },
    {
        "x": 425.20171673819743,
        "y": 279.07296137339057
    },
    {
        "x": 426.30042918454933,
        "y": 280.17167381974247
    },
    {
        "x": 426.30042918454933,
        "y": 282.3690987124464
    },
    {
        "x": 426.30042918454933,
        "y": 282.3690987124464
    },
    {
        "x": 426.30042918454933,
        "y": 283.46781115879827
    },
    {
        "x": 426.30042918454933,
        "y": 284.5665236051502
    },
    {
        "x": 426.30042918454933,
        "y": 285.6652360515021
    },
    {
        "x": 427.3991416309013,
        "y": 285.6652360515021
    },
    {
        "x": 427.3991416309013,
        "y": 286.7639484978541
    },
    {
        "x": 427.3991416309013,
        "y": 286.7639484978541
    },
    {
        "x": 427.3991416309013,
        "y": 288.9613733905579
    },
    {
        "x": 427.3991416309013,
        "y": 291.1587982832618
    },
    {
        "x": 427.3991416309013,
        "y": 291.1587982832618
    },
    {
        "x": 427.3991416309013,
        "y": 292.2575107296137
    },
    {
        "x": 427.3991416309013,
        "y": 293.3562231759657
    },
    {
        "x": 427.3991416309013,
        "y": 294.4549356223176
    },
    {
        "x": 427.3991416309013,
        "y": 295.55364806866953
    },
    {
        "x": 427.3991416309013,
        "y": 295.55364806866953
    },
    {
        "x": 427.3991416309013,
        "y": 296.6523605150215
    },
    {
        "x": 427.3991416309013,
        "y": 298.84978540772534
    },
    {
        "x": 427.3991416309013,
        "y": 299.94849785407723
    },
    {
        "x": 427.3991416309013,
        "y": 299.94849785407723
    },
    {
        "x": 427.3991416309013,
        "y": 301.0472103004292
    },
    {
        "x": 427.3991416309013,
        "y": 302.14592274678114
    },
    {
        "x": 427.3991416309013,
        "y": 303.24463519313304
    },
    {
        "x": 427.3991416309013,
        "y": 304.343347639485
    },
    {
        "x": 427.3991416309013,
        "y": 304.343347639485
    },
    {
        "x": 427.3991416309013,
        "y": 305.4420600858369
    },
    {
        "x": 427.3991416309013,
        "y": 306.54077253218884
    },
    {
        "x": 427.3991416309013,
        "y": 307.6394849785408
    },
    {
        "x": 427.3991416309013,
        "y": 308.7381974248927
    },
    {
        "x": 427.3991416309013,
        "y": 308.7381974248927
    }
  ],
  "letter_2":[
    {
        "x": 474.6437768240343,
        "y": 275.77682403433477
    },
    {
        "x": 474.6437768240343,
        "y": 277.9742489270386
    },
    {
        "x": 474.6437768240343,
        "y": 279.07296137339057
    },
    {
        "x": 474.6437768240343,
        "y": 280.17167381974247
    },
    {
        "x": 474.6437768240343,
        "y": 282.3690987124464
    },
    {
        "x": 474.6437768240343,
        "y": 282.3690987124464
    },
    {
        "x": 474.6437768240343,
        "y": 283.46781115879827
    },
    {
        "x": 474.6437768240343,
        "y": 284.5665236051502
    },
    {
        "x": 474.6437768240343,
        "y": 285.6652360515021
    },
    {
        "x": 474.6437768240343,
        "y": 286.7639484978541
    },
    {
        "x": 474.6437768240343,
        "y": 286.7639484978541
    },
    {
        "x": 474.6437768240343,
        "y": 286.7639484978541
    },
    {
        "x": 473.5450643776824,
        "y": 284.5665236051502
    },
    {
        "x": 472.44635193133047,
        "y": 283.46781115879827
    },
    {
        "x": 472.44635193133047,
        "y": 282.3690987124464
    },
    {
        "x": 472.44635193133047,
        "y": 282.3690987124464
    },
    {
        "x": 471.3476394849785,
        "y": 281.2703862660944
    },
    {
        "x": 470.2489270386266,
        "y": 280.17167381974247
    },
    {
        "x": 470.2489270386266,
        "y": 277.9742489270386
    },
    {
        "x": 470.2489270386266,
        "y": 276.8755364806867
    },
    {
        "x": 469.15021459227466,
        "y": 275.77682403433477
    },
    {
        "x": 468.05150214592277,
        "y": 274.6781115879828
    },
    {
        "x": 468.05150214592277,
        "y": 273.5793991416309
    },
    {
        "x": 466.9527896995708,
        "y": 273.5793991416309
    },
    {
        "x": 465.85407725321886,
        "y": 272.48068669527896
    },
    {
        "x": 465.85407725321886,
        "y": 272.48068669527896
    },
    {
        "x": 465.85407725321886,
        "y": 271.38197424892707
    },
    {
        "x": 464.75536480686696,
        "y": 271.38197424892707
    },
    {
        "x": 462.5579399141631,
        "y": 271.38197424892707
    },
    {
        "x": 455.9656652360515,
        "y": 273.5793991416309
    },
    {
        "x": 454.86695278969955,
        "y": 273.5793991416309
    },
    {
        "x": 453.76824034334766,
        "y": 274.6781115879828
    },
    {
        "x": 452.6695278969957,
        "y": 275.77682403433477
    },
    {
        "x": 452.6695278969957,
        "y": 276.8755364806867
    },
    {
        "x": 451.57081545064375,
        "y": 276.8755364806867
    },
    {
        "x": 451.57081545064375,
        "y": 277.9742489270386
    },
    {
        "x": 450.47210300429185,
        "y": 277.9742489270386
    },
    {
        "x": 449.3733905579399,
        "y": 277.9742489270386
    },
    {
        "x": 448.274678111588,
        "y": 277.9742489270386
    },
    {
        "x": 448.274678111588,
        "y": 279.07296137339057
    },
    {
        "x": 446.0772532188841,
        "y": 280.17167381974247
    },
    {
        "x": 446.0772532188841,
        "y": 281.2703862660944
    },
    {
        "x": 446.0772532188841,
        "y": 282.3690987124464
    },
    {
        "x": 446.0772532188841,
        "y": 286.7639484978541
    },
    {
        "x": 446.0772532188841,
        "y": 287.862660944206
    },
    {
        "x": 446.0772532188841,
        "y": 291.1587982832618
    },
    {
        "x": 446.0772532188841,
        "y": 293.3562231759657
    },
    {
        "x": 447.17596566523605,
        "y": 294.4549356223176
    },
    {
        "x": 448.274678111588,
        "y": 295.55364806866953
    },
    {
        "x": 448.274678111588,
        "y": 297.7510729613734
    },
    {
        "x": 448.274678111588,
        "y": 298.84978540772534
    },
    {
        "x": 448.274678111588,
        "y": 299.94849785407723
    },
    {
        "x": 448.274678111588,
        "y": 299.94849785407723
    },
    {
        "x": 449.3733905579399,
        "y": 301.0472103004292
    },
    {
        "x": 449.3733905579399,
        "y": 302.14592274678114
    },
    {
        "x": 450.47210300429185,
        "y": 303.24463519313304
    },
    {
        "x": 451.57081545064375,
        "y": 304.343347639485
    },
    {
        "x": 451.57081545064375,
        "y": 304.343347639485
    },
    {
        "x": 451.57081545064375,
        "y": 305.4420600858369
    },
    {
        "x": 452.6695278969957,
        "y": 308.7381974248927
    },
    {
        "x": 454.86695278969955,
        "y": 308.7381974248927
    },
    {
        "x": 455.9656652360515,
        "y": 308.7381974248927
    },
    {
        "x": 457.06437768240346,
        "y": 308.7381974248927
    },
    {
        "x": 457.06437768240346,
        "y": 308.7381974248927
    },
    {
        "x": 458.16309012875536,
        "y": 308.7381974248927
    },
    {
        "x": 459.2618025751073,
        "y": 308.7381974248927
    },
    {
        "x": 460.3605150214592,
        "y": 308.7381974248927
    },
    {
        "x": 461.45922746781116,
        "y": 308.7381974248927
    },
    {
        "x": 462.5579399141631,
        "y": 308.7381974248927
    },
    {
        "x": 463.656652360515,
        "y": 308.7381974248927
    },
    {
        "x": 465.85407725321886,
        "y": 308.7381974248927
    },
    {
        "x": 466.9527896995708,
        "y": 307.6394849785408
    },
    {
        "x": 468.05150214592277,
        "y": 306.54077253218884
    },
    {
        "x": 470.2489270386266,
        "y": 304.343347639485
    },
    {
        "x": 470.2489270386266,
        "y": 304.343347639485
    },
    {
        "x": 470.2489270386266,
        "y": 303.24463519313304
    },
    {
        "x": 472.44635193133047,
        "y": 301.0472103004292
    },
    {
        "x": 472.44635193133047,
        "y": 299.94849785407723
    },
    {
        "x": 472.44635193133047,
        "y": 299.94849785407723
    },
    {
        "x": 473.5450643776824,
        "y": 298.84978540772534
    },
    {
        "x": 473.5450643776824,
        "y": 297.7510729613734
    },
    {
        "x": 473.5450643776824,
        "y": 296.6523605150215
    },
    {
        "x": 473.5450643776824,
        "y": 295.55364806866953
    },
    {
        "x": 473.5450643776824,
        "y": 295.55364806866953
    },
    {
        "x": 473.5450643776824,
        "y": 294.4549356223176
    },
    {
        "x": 473.5450643776824,
        "y": 293.3562231759657
    },
    {
        "x": 473.5450643776824,
        "y": 292.2575107296137
    },
    {
        "x": 473.5450643776824,
        "y": 291.1587982832618
    },
    {
        "x": 473.5450643776824,
        "y": 290.0600858369099
    },
    {
        "x": 473.5450643776824,
        "y": 288.9613733905579
    },
    {
        "x": 473.5450643776824,
        "y": 290.0600858369099
    },
    {
        "x": 473.5450643776824,
        "y": 291.1587982832618
    },
    {
        "x": 473.5450643776824,
        "y": 293.3562231759657
    },
    {
        "x": 473.5450643776824,
        "y": 295.55364806866953
    },
    {
        "x": 473.5450643776824,
        "y": 295.55364806866953
    },
    {
        "x": 473.5450643776824,
        "y": 296.6523605150215
    },
    {
        "x": 473.5450643776824,
        "y": 298.84978540772534
    },
    {
        "x": 473.5450643776824,
        "y": 299.94849785407723
    },
    {
        "x": 473.5450643776824,
        "y": 299.94849785407723
    },
    {
        "x": 473.5450643776824,
        "y": 301.0472103004292
    },
    {
        "x": 473.5450643776824,
        "y": 303.24463519313304
    },
    {
        "x": 473.5450643776824,
        "y": 304.343347639485
    },
    {
        "x": 474.6437768240343,
        "y": 304.343347639485
    },
    {
        "x": 474.6437768240343,
        "y": 304.343347639485
    },
    {
        "x": 474.6437768240343,
        "y": 305.4420600858369
    },
    {
        "x": 474.6437768240343,
        "y": 306.54077253218884
    },
    {
        "x": 474.6437768240343,
        "y": 307.6394849785408
    },
    {
        "x": 474.6437768240343,
        "y": 308.7381974248927
    }
  ],
  "letter_3":[
    {
        "x": 487.82832618025753,
        "y": 269.18454935622316
    },
    {
        "x": 490.0257510729614,
        "y": 269.18454935622316
    },
    {
        "x": 491.1244635193133,
        "y": 269.18454935622316
    },
    {
        "x": 494.4206008583691,
        "y": 269.18454935622316
    },
    {
        "x": 496.61802575107293,
        "y": 269.18454935622316
    },
    {
        "x": 497.7167381974249,
        "y": 269.18454935622316
    },
    {
        "x": 499.91416309012874,
        "y": 269.18454935622316
    },
    {
        "x": 503.21030042918454,
        "y": 269.18454935622316
    },
    {
        "x": 505.4077253218884,
        "y": 269.18454935622316
    },
    {
        "x": 506.50643776824035,
        "y": 269.18454935622316
    },
    {
        "x": 507.6051502145923,
        "y": 269.18454935622316
    },
    {
        "x": 508.7038626609442,
        "y": 269.18454935622316
    },
    {
        "x": 509.80257510729615,
        "y": 269.18454935622316
    },
    {
        "x": 509.80257510729615,
        "y": 269.18454935622316
    },
    {
        "x": 510.90128755364805,
        "y": 269.18454935622316
    },
    {
        "x": 512,
        "y": 269.18454935622316
    },
    {
        "x": 514.1974248927039,
        "y": 269.18454935622316
    },
    {
        "x": 514.1974248927039,
        "y": 269.18454935622316
    },
    {
        "x": 515.2961373390558,
        "y": 269.18454935622316
    },
    {
        "x": 516.3948497854077,
        "y": 269.18454935622316
    },
    {
        "x": 517.4935622317597,
        "y": 269.18454935622316
    },
    {
        "x": 518.5922746781116,
        "y": 269.18454935622316
    },
    {
        "x": 518.5922746781116,
        "y": 270.2832618025751
    },
    {
        "x": 518.5922746781116,
        "y": 272.48068669527896
    },
    {
        "x": 516.3948497854077,
        "y": 273.5793991416309
    },
    {
        "x": 515.2961373390558,
        "y": 274.6781115879828
    },
    {
        "x": 515.2961373390558,
        "y": 275.77682403433477
    },
    {
        "x": 515.2961373390558,
        "y": 277.9742489270386
    },
    {
        "x": 514.1974248927039,
        "y": 277.9742489270386
    },
    {
        "x": 514.1974248927039,
        "y": 279.07296137339057
    },
    {
        "x": 513.0987124463519,
        "y": 280.17167381974247
    },
    {
        "x": 513.0987124463519,
        "y": 281.2703862660944
    },
    {
        "x": 510.90128755364805,
        "y": 283.46781115879827
    },
    {
        "x": 509.80257510729615,
        "y": 286.7639484978541
    },
    {
        "x": 509.80257510729615,
        "y": 286.7639484978541
    },
    {
        "x": 508.7038626609442,
        "y": 287.862660944206
    },
    {
        "x": 507.6051502145923,
        "y": 287.862660944206
    },
    {
        "x": 507.6051502145923,
        "y": 288.9613733905579
    },
    {
        "x": 506.50643776824035,
        "y": 291.1587982832618
    },
    {
        "x": 505.4077253218884,
        "y": 291.1587982832618
    },
    {
        "x": 505.4077253218884,
        "y": 291.1587982832618
    },
    {
        "x": 505.4077253218884,
        "y": 292.2575107296137
    },
    {
        "x": 504.3090128755365,
        "y": 293.3562231759657
    },
    {
        "x": 504.3090128755365,
        "y": 294.4549356223176
    },
    {
        "x": 503.21030042918454,
        "y": 295.55364806866953
    },
    {
        "x": 502.1115879828326,
        "y": 295.55364806866953
    },
    {
        "x": 501.0128755364807,
        "y": 296.6523605150215
    },
    {
        "x": 501.0128755364807,
        "y": 297.7510729613734
    },
    {
        "x": 498.81545064377684,
        "y": 299.94849785407723
    },
    {
        "x": 496.61802575107293,
        "y": 301.0472103004292
    },
    {
        "x": 495.51931330472104,
        "y": 301.0472103004292
    },
    {
        "x": 494.4206008583691,
        "y": 302.14592274678114
    },
    {
        "x": 493.3218884120172,
        "y": 302.14592274678114
    },
    {
        "x": 495.51931330472104,
        "y": 302.14592274678114
    },
    {
        "x": 496.61802575107293,
        "y": 302.14592274678114
    },
    {
        "x": 497.7167381974249,
        "y": 302.14592274678114
    },
    {
        "x": 499.91416309012874,
        "y": 302.14592274678114
    },
    {
        "x": 501.0128755364807,
        "y": 302.14592274678114
    },
    {
        "x": 502.1115879828326,
        "y": 302.14592274678114
    },
    {
        "x": 505.4077253218884,
        "y": 302.14592274678114
    },
    {
        "x": 505.4077253218884,
        "y": 302.14592274678114
    },
    {
        "x": 507.6051502145923,
        "y": 302.14592274678114
    },
    {
        "x": 508.7038626609442,
        "y": 302.14592274678114
    },
    {
        "x": 509.80257510729615,
        "y": 302.14592274678114
    },
    {
        "x": 510.90128755364805,
        "y": 302.14592274678114
    },
    {
        "x": 512,
        "y": 302.14592274678114
    },
    {
        "x": 513.0987124463519,
        "y": 302.14592274678114
    },
    {
        "x": 513.0987124463519,
        "y": 303.24463519313304
    }
  ],
  "letter_4":[
    {
        "x": 549.3562231759656,
        "y": 269.18454935622316
    },
    {
        "x": 549.3562231759656,
        "y": 270.2832618025751
    },
    {
        "x": 549.3562231759656,
        "y": 271.38197424892707
    },
    {
        "x": 549.3562231759656,
        "y": 273.5793991416309
    },
    {
        "x": 549.3562231759656,
        "y": 274.6781115879828
    },
    {
        "x": 549.3562231759656,
        "y": 275.77682403433477
    },
    {
        "x": 549.3562231759656,
        "y": 277.9742489270386
    },
    {
        "x": 549.3562231759656,
        "y": 279.07296137339057
    },
    {
        "x": 549.3562231759656,
        "y": 281.2703862660944
    },
    {
        "x": 549.3562231759656,
        "y": 282.3690987124464
    },
    {
        "x": 549.3562231759656,
        "y": 283.46781115879827
    },
    {
        "x": 549.3562231759656,
        "y": 284.5665236051502
    },
    {
        "x": 550.4549356223176,
        "y": 285.6652360515021
    },
    {
        "x": 550.4549356223176,
        "y": 286.7639484978541
    },
    {
        "x": 551.5536480686695,
        "y": 286.7639484978541
    },
    {
        "x": 551.5536480686695,
        "y": 288.9613733905579
    },
    {
        "x": 552.6523605150214,
        "y": 291.1587982832618
    },
    {
        "x": 552.6523605150214,
        "y": 291.1587982832618
    },
    {
        "x": 553.7510729613734,
        "y": 292.2575107296137
    },
    {
        "x": 553.7510729613734,
        "y": 293.3562231759657
    },
    {
        "x": 553.7510729613734,
        "y": 294.4549356223176
    },
    {
        "x": 553.7510729613734,
        "y": 295.55364806866953
    },
    {
        "x": 554.8497854077253,
        "y": 295.55364806866953
    },
    {
        "x": 555.9484978540772,
        "y": 296.6523605150215
    },
    {
        "x": 558.1459227467811,
        "y": 298.84978540772534
    },
    {
        "x": 559.244635193133,
        "y": 299.94849785407723
    },
    {
        "x": 560.3433476394849,
        "y": 299.94849785407723
    },
    {
        "x": 560.3433476394849,
        "y": 299.94849785407723
    },
    {
        "x": 561.4420600858369,
        "y": 299.94849785407723
    },
    {
        "x": 562.5407725321888,
        "y": 299.94849785407723
    },
    {
        "x": 562.5407725321888,
        "y": 301.0472103004292
    },
    {
        "x": 563.6394849785407,
        "y": 301.0472103004292
    },
    {
        "x": 564.7381974248927,
        "y": 301.0472103004292
    },
    {
        "x": 565.8369098712446,
        "y": 301.0472103004292
    },
    {
        "x": 566.9356223175965,
        "y": 302.14592274678114
    },
    {
        "x": 566.9356223175965,
        "y": 302.14592274678114
    },
    {
        "x": 568.0343347639486,
        "y": 302.14592274678114
    },
    {
        "x": 570.2317596566523,
        "y": 302.14592274678114
    },
    {
        "x": 571.3304721030042,
        "y": 302.14592274678114
    },
    {
        "x": 571.3304721030042,
        "y": 302.14592274678114
    },
    {
        "x": 573.5278969957081,
        "y": 302.14592274678114
    },
    {
        "x": 575.725321888412,
        "y": 302.14592274678114
    },
    {
        "x": 576.824034334764,
        "y": 301.0472103004292
    },
    {
        "x": 579.0214592274679,
        "y": 299.94849785407723
    },
    {
        "x": 580.1201716738198,
        "y": 297.7510729613734
    },
    {
        "x": 580.1201716738198,
        "y": 296.6523605150215
    },
    {
        "x": 581.2188841201717,
        "y": 296.6523605150215
    },
    {
        "x": 582.3175965665235,
        "y": 295.55364806866953
    },
    {
        "x": 582.3175965665235,
        "y": 293.3562231759657
    },
    {
        "x": 582.3175965665235,
        "y": 291.1587982832618
    },
    {
        "x": 583.4163090128756,
        "y": 290.0600858369099
    },
    {
        "x": 583.4163090128756,
        "y": 287.862660944206
    },
    {
        "x": 583.4163090128756,
        "y": 286.7639484978541
    },
    {
        "x": 583.4163090128756,
        "y": 285.6652360515021
    },
    {
        "x": 583.4163090128756,
        "y": 283.46781115879827
    },
    {
        "x": 583.4163090128756,
        "y": 282.3690987124464
    },
    {
        "x": 584.5150214592275,
        "y": 282.3690987124464
    },
    {
        "x": 584.5150214592275,
        "y": 282.3690987124464
    },
    {
        "x": 584.5150214592275,
        "y": 280.17167381974247
    },
    {
        "x": 584.5150214592275,
        "y": 279.07296137339057
    },
    {
        "x": 584.5150214592275,
        "y": 277.9742489270386
    },
    {
        "x": 584.5150214592275,
        "y": 276.8755364806867
    },
    {
        "x": 583.4163090128756,
        "y": 275.77682403433477
    },
    {
        "x": 583.4163090128756,
        "y": 273.5793991416309
    },
    {
        "x": 582.3175965665235,
        "y": 273.5793991416309
    },
    {
        "x": 581.2188841201717,
        "y": 273.5793991416309
    },
    {
        "x": 580.1201716738198,
        "y": 271.38197424892707
    },
    {
        "x": 580.1201716738198,
        "y": 270.2832618025751
    },
    {
        "x": 580.1201716738198,
        "y": 270.2832618025751
    },
    {
        "x": 579.0214592274679,
        "y": 269.18454935622316
    },
    {
        "x": 579.0214592274679,
        "y": 269.18454935622316
    },
    {
        "x": 577.9227467811158,
        "y": 268.08583690987126
    },
    {
        "x": 576.824034334764,
        "y": 266.9871244635193
    },
    {
        "x": 576.824034334764,
        "y": 265.88841201716735
    },
    {
        "x": 575.725321888412,
        "y": 265.88841201716735
    },
    {
        "x": 575.725321888412,
        "y": 264.78969957081546
    },
    {
        "x": 575.725321888412,
        "y": 263.6909871244635
    }
  ],
  "letter_5":[
    {
        "x": 598.7274133519255,
        "y": 299.36371976833226
    },
    {
        "x": 598.7274133519255,
        "y": 298.2631178574193
    },
    {
        "x": 598.7274133519255,
        "y": 297.1625159465063
    },
    {
        "x": 598.7274133519255,
        "y": 296.0619140355933
    },
    {
        "x": 598.7274133519255,
        "y": 294.9613121246803
    },
    {
        "x": 598.7274133519255,
        "y": 293.86071021376733
    },
    {
        "x": 598.7274133519255,
        "y": 292.76010830285435
    },
    {
        "x": 598.7274133519255,
        "y": 291.65950639194136
    },
    {
        "x": 598.7274133519255,
        "y": 291.65950639194136
    },
    {
        "x": 598.7274133519255,
        "y": 289.4583025701154
    },
    {
        "x": 598.7274133519255,
        "y": 286.15649683737644
    },
    {
        "x": 598.7274133519255,
        "y": 283.95529301555047
    },
    {
        "x": 598.7274133519255,
        "y": 282.8546911046375
    },
    {
        "x": 597.6268114891462,
        "y": 280.6534872828115
    },
    {
        "x": 596.526209626367,
        "y": 278.45228346098554
    },
    {
        "x": 596.526209626367,
        "y": 277.35168155007256
    },
    {
        "x": 596.526209626367,
        "y": 276.25107963915957
    },
    {
        "x": 596.526209626367,
        "y": 274.0498758173336
    },
    {
        "x": 595.4256077635877,
        "y": 272.9492739064206
    },
    {
        "x": 595.4256077635877,
        "y": 270.74807008459464
    },
    {
        "x": 595.4256077635877,
        "y": 269.64746817368166
    },
    {
        "x": 595.4256077635877,
        "y": 267.4462643518557
    },
    {
        "x": 595.4256077635877,
        "y": 266.3456624409427
    },
    {
        "x": 595.4256077635877,
        "y": 265.2450605300297
    },
    {
        "x": 594.3250059008084,
        "y": 265.2450605300297
    },
    {
        "x": 594.3250059008084,
        "y": 263.04385670820375
    },
    {
        "x": 594.3250059008084,
        "y": 261.94325479729076
    },
    {
        "x": 594.3250059008084,
        "y": 260.8426528863778
    },
    {
        "x": 594.3250059008084,
        "y": 260.8426528863778
    },
    {
        "x": 594.3250059008084,
        "y": 259.7420509754648
    },
    {
        "x": 594.3250059008084,
        "y": 258.6414490645518
    },
    {
        "x": 594.3250059008084,
        "y": 260.8426528863778
    },
    {
        "x": 595.4256077635877,
        "y": 261.94325479729076
    },
    {
        "x": 595.4256077635877,
        "y": 265.2450605300297
    },
    {
        "x": 595.4256077635877,
        "y": 266.3456624409427
    },
    {
        "x": 595.4256077635877,
        "y": 269.64746817368166
    },
    {
        "x": 595.4256077635877,
        "y": 271.84867199550763
    },
    {
        "x": 595.4256077635877,
        "y": 274.0498758173336
    },
    {
        "x": 595.4256077635877,
        "y": 274.0498758173336
    },
    {
        "x": 595.4256077635877,
        "y": 275.1504777282466
    },
    {
        "x": 595.4256077635877,
        "y": 276.25107963915957
    },
    {
        "x": 595.4256077635877,
        "y": 278.45228346098554
    },
    {
        "x": 597.6268114891462,
        "y": 274.0498758173336
    },
    {
        "x": 598.7274133519255,
        "y": 272.9492739064206
    },
    {
        "x": 598.7274133519255,
        "y": 270.74807008459464
    },
    {
        "x": 598.7274133519255,
        "y": 269.64746817368166
    },
    {
        "x": 598.7274133519255,
        "y": 269.64746817368166
    },
    {
        "x": 598.7274133519255,
        "y": 268.5468662627687
    },
    {
        "x": 599.8280152147048,
        "y": 268.5468662627687
    },
    {
        "x": 602.0292189402634,
        "y": 266.3456624409427
    },
    {
        "x": 603.1298208030427,
        "y": 264.14445861911673
    },
    {
        "x": 604.230422665822,
        "y": 264.14445861911673
    },
    {
        "x": 605.3310245286011,
        "y": 263.04385670820375
    },
    {
        "x": 606.4316263913804,
        "y": 261.94325479729076
    },
    {
        "x": 607.5322282541597,
        "y": 260.8426528863778
    },
    {
        "x": 608.632830116939,
        "y": 260.8426528863778
    },
    {
        "x": 609.7334319797183,
        "y": 260.8426528863778
    },
    {
        "x": 610.8340338424975,
        "y": 260.8426528863778
    },
    {
        "x": 611.9346357052768,
        "y": 260.8426528863778
    },
    {
        "x": 611.9346357052768,
        "y": 260.8426528863778
    },
    {
        "x": 613.0352375680561,
        "y": 260.8426528863778
    },
    {
        "x": 615.2364412936147,
        "y": 260.8426528863778
    },
    {
        "x": 616.337043156394,
        "y": 260.8426528863778
    },
    {
        "x": 617.4376450191731,
        "y": 260.8426528863778
    },
    {
        "x": 618.5382468819524,
        "y": 260.8426528863778
    },
    {
        "x": 619.6388487447317,
        "y": 260.8426528863778
    },
    {
        "x": 620.739450607511,
        "y": 260.8426528863778
    },
    {
        "x": 620.739450607511,
        "y": 261.94325479729076
    },
    {
        "x": 620.739450607511,
        "y": 263.04385670820375
    },
    {
        "x": 621.8400524702903,
        "y": 265.2450605300297
    },
    {
        "x": 621.8400524702903,
        "y": 268.5468662627687
    },
    {
        "x": 621.8400524702903,
        "y": 271.84867199550763
    },
    {
        "x": 621.8400524702903,
        "y": 274.0498758173336
    },
    {
        "x": 621.8400524702903,
        "y": 276.25107963915957
    },
    {
        "x": 621.8400524702903,
        "y": 278.45228346098554
    },
    {
        "x": 621.8400524702903,
        "y": 280.6534872828115
    },
    {
        "x": 621.8400524702903,
        "y": 281.7540891937245
    },
    {
        "x": 621.8400524702903,
        "y": 282.8546911046375
    },
    {
        "x": 621.8400524702903,
        "y": 283.95529301555047
    },
    {
        "x": 621.8400524702903,
        "y": 285.05589492646345
    },
    {
        "x": 620.739450607511,
        "y": 287.2570987482894
    },
    {
        "x": 620.739450607511,
        "y": 288.3577006592024
    },
    {
        "x": 620.739450607511,
        "y": 289.4583025701154
    },
    {
        "x": 620.739450607511,
        "y": 290.5589044810284
    },
    {
        "x": 620.739450607511,
        "y": 291.65950639194136
    },
    {
        "x": 620.739450607511,
        "y": 292.76010830285435
    },
    {
        "x": 620.739450607511,
        "y": 293.86071021376733
    },
    {
        "x": 620.739450607511,
        "y": 294.9613121246803
    },
    {
        "x": 620.739450607511,
        "y": 296.0619140355933
    },
    {
        "x": 620.739450607511,
        "y": 296.0619140355933
    },
    {
        "x": 620.739450607511,
        "y": 297.1625159465063
    },
    {
        "x": 621.8400524702903,
        "y": 297.1625159465063
    },
    {
        "x": 624.0412561958489,
        "y": 299.36371976833226
    },
    {
        "x": 624.0412561958489,
        "y": 300.46432167924524
    }
  ]
}